/* eslint-disable prettier/prettier */
export const en = {
    //Topbar
    helpLinkTitle: 'Help',
    signOutActionTitle: 'Sign out',
    experimentalFeatures: 'Experimental features',
    leaveActionTitle: 'Leave Campus',
    leaveActionMessage: 'To leave Campus, simply close the tab in your browser. When you reopen the Campus web-page, you will return directly to your office.',
    logOutFromSystem: 'Click here',
    logOutFromSystemTwo: 'to log out.',
    changeLocationTo: 'Change location to',
    changeAreaGroupTo: 'Change area to',
    enterOffice: 'Enter office',
    enterOfficeOf: 'Enter office of',
    createNewBuilding: 'Create new building',
    areaGroup: 'AREA GROUP',

    // Identity Panel
    appearenceModification: 'Profile appearance',
    identityPanelTitle: 'My settings',
    profileTabTitle: 'Profile',
    widgetsTabTitle: 'Widgets',
    dashboardWidgetsHeading: 'Personal Desk',
    dashboardWidgetsHelperText: 'All other widgets can be hidden here if you do not want to see them on the desktop.',
    dashboardWidgetsMatrixNote:
        'Note: The Matrix E2EE Chat widget is always displayed on the desktop for all CAMPUS users and cannot be hidden there.',
    dashboardWidgetOutlookLabel: 'Outlook',
    dashboardWidgetCalendarLabel: 'Calendar',
    dashboardWidgetTasksLabel: 'Tasks',
    dashboardWidgetZammadLabel: 'Zammad',
    dashboardWidgetOpenProjectLabel: 'OpenProject',
    preferencesTabTitle: 'Preferences',
    switchOrgActionTitle: 'Switch organisation',
    updateImageActionTitle: 'Update image',
    changeEmailActionTitle: 'Change email',
    cameraPreferenceActionTitle: 'Disable camera when entering a room?',
    microphonePreferenceActionTitle: 'Disable microphone when entering a room?',
    enableCameraActionTitle: 'Enable camera on room entry',
    disableCameraActionTitle: 'Disable camera on room entry',
    enableMicrophoneActionTitle: 'Enable microphone on room entry',
    disableMicrophoneActionTitle: 'Disable microphone on room entry',
    // Status Actions
    statusAtWork: 'At work',
    statusAway: 'Briefly absent',
    statusDoNotDisturb: 'Please do not disturb',
    statusOutOfOffice: 'Not at the workplace',
    statusOnThePhone: 'On a call',
    statusCurrent: 'Current status',
    // At-work location options
    atWorkOptionOffice: 'Office',
    atWorkOptionRemote: 'Remote',
    atWorkOptionOtherLocation: 'Other location',
    atWorkCreatePersonalMessage: 'Show personal message',
    atWorkModalTitle: 'Create notice',
    atWorkModalDescription: 'Enter your own text, which will be shown to others when you are at work to indicate your location or activity.',
    atWorkMessagePlaceholder: 'Enter your location, a status description or a text that will be displayed next to your profile picture.',
    // Away Status Options
    awayOptionCoffee: 'Getting coffee quickly',
    awayOptionComingBack: 'Coming back immediately',
    awayCustomMessage: 'Away for a little while',
    awayCreatePersonalMessage: 'Create personal message',
    awayMessagePlaceholder: 'Enter your message',
    // Custom Away Message Modal
    awayModalTitle: 'Create Personal Away Message',
    awayModalDescription: 'Enter your own text, which will be shown to others during your yellow status to comment on your short absence.',
    awayCharactersLabel: 'characters',
    awayCharactersRemaining: 'remaining',
    awayModalConfirm: 'Save',
    awayModalCancel: 'Discard',
    awayModalCloseAriaLabel: 'Close',
    // Focus Time / Do Not Disturb modal
    focusTimeModalTitle: 'Specify focus time',
    focusTimeSelectDuration: 'Select duration',
    focusTime15Min: '15 min',
    focusTime30Min: '30 min',
    focusTime45Min: '45 min',
    focusTime1H: '1 h',
    focusTime1_5H: '1.5 h',
    focusTime2H: '2 h',
    focusTime2_5H: '2.5 h',
    focusTime3H: '3 h',
    focusTimeMaxDurationError: 'Maximum duration is 3 hours. Set to 3 hours.',
    focusTimeStartTimePastError: 'Start time cannot be earlier than current time.',
    focusTimeStartOrEndTimePastError: 'Start or end time cannot be earlier than current time.',
    focusTimeMore: 'More',
    focusTimeTotalDuration: 'Total duration',
    focusTimeSetTimeInterval: 'Set time interval',
    focusTimeStartTime: 'Start time',
    focusTimeEndTime: 'End time',
    focusTimeEmergencyQuestion: 'How would you like to be contacted in an emergency?',
    focusTimeKnockDoor: 'By inviting to your room',
    focusTimeTextMessage: 'Via fluid chat',
    focusTimeDone: 'Done',
    focusTimeCancel: 'Cancel',
    focusTimeCloseAriaLabel: 'Close',
    focusExtendEndModalTitle: 'Focus time ended since',
    focusExtendEndModalMessage: 'Would you like to extend your focus time or end it?',
    focusExtendEndExtend: 'Extend',
    focusExtendEndEnd: 'End',
    focusExtendEndCloseAriaLabel: 'Close',
    focusWorkUntilEnd: 'Focus work until',
    focusTimeEmergencyContactLabel: 'Emergency contact via:',
    onPhoneModalTitle: 'On the phone',
    onCallModalTitle: 'On a call',
    onCallModalConfirm: 'Confirm',
    onCallModalCancel: 'Cancel',
    onCallModalCloseAriaLabel: 'Close',
    onCallUntilEnd: 'On a call until',
    onCallEndedModalTitle: 'Are you still on the phone?',
    onCallEndedForAnother: 'For another',
    onCallEndedAutoCloseLabel: 'Return to work if no response in:',
    onCallEndedNo: 'No',
    onCallEndedYes: 'Yes',
    onCallEndedCloseAriaLabel: 'Close',
    awayExtensionModalTitle: 'You seem to be absent on your CAMPUS',
    awayExtensionModalBody: 'Would you like to change your status?',
    awayExtensionModalLogoutLabel: 'You will be redirected to Lobby if no response in:',
    awayExtensionModalNo: 'No',
    awayExtensionModalYes: 'Yes',
    awayExtensionModalCloseAriaLabel: 'Close',
    awayTimeoutAlertTitle: 'The status you selected in CAMPUS is no longer corresponded to the actual situation, so you were directed to the lobby.',
    awayTimeoutAlertButton: 'Okay. Got it.',
    lobbyModalInactivityDetectedText: 'You were guided to the lobby because you did not respond to inquiries and had been inactive for some time.',
    lobbyModalInactivityDetectedButton: 'Got it',
    lobbyModalOooInactivityText: 'You were guided to the lobby because you did not respond to inquiries and had been inactive for some time.',
    lobbyModalOooInactivityButton: 'Got it',
    lobbyModalStatusUpdatedText: 'You were away for a while, so your status was set to Out of Office and you were redirected to the lobby.',
    lobbyModalStatusUpdatedButton: 'Got it',
    lobbyModalMidnightStatusUpdateText: 'It\'s past midnight. Your status was automatically set to Out of Office and you were redirected to the lobby.',
    lobbyModalMidnightStatusUpdateButton: 'Got it',
    lobbyInactivityWarningTitle: 'Long absence',
    lobbyInactivityWarningText: 'You haven\'t been active on CAMPUS for hours, so you\'re about to be signed out:',
    lobbyInactivityWarningButton: 'Stay on CAMPUS',
    presencePromptTitle: 'Are you still there?',
    presencePromptButton: 'I\'m still here',
    presencePromptIdleChainText: 'You haven\'t been active on CAMPUS for a while. If you don\'t respond, you will be moved to the Lobby in:',
    presencePromptManualOooTodayText: 'You are out of office and haven\'t been active on CAMPUS for a while. If you don\'t respond, you will be moved to the Lobby in:',
    presencePromptManualOooLogoutText: 'You are out of office and haven\'t been active on CAMPUS for a while. If you don\'t respond, you will be signed out in:',
    presencePromptMidnightText: 'It\'s past midnight and you haven\'t been active on CAMPUS for the last hour. If you don\'t respond, your status will be set to out of office and you will be moved to the Lobby in:',
    sessionTakeoverReplacedTitle: 'Campus is open in another tab or device',
    sessionTakeoverReplacedText: 'You can only use Campus in one place at a time.',
    sessionTakeoverUseHereButton: 'Use here',
    sessionTakeoverOpenElsewhereTitle: 'Campus is already open in another tab or device',
    sessionTakeoverOpenElsewhereText: 'You can only use Campus in one place at a time. Do you want to use it here instead?',
    sessionTakeoverKeepOtherButton: 'Keep the other one',
    sessionTakeoverInCallTitle: 'You\'re in a call in another tab or device',
    sessionTakeoverInCallText: 'Continuing here will end that call.',
    sessionTakeoverContinueButton: 'Continue here',
    sessionTakeoverCancelButton: 'Cancel',
    oooReminderTitle: 'You are shown as out of office',
    oooReminderText: 'Your status is still set to out of office and is shown to others. Would you like to change your status?',
    oooReminderExpiredTitle: 'Your out-of-office has ended',
    oooReminderExpiredText: 'Your out-of-office status was set until {date} and is still shown to others. Would you like to change your status?',
    oooReminderKeep: 'Keep out of office',
    oooReminderSetAtWork: 'Set to At work',
    onPhoneModalOptionInCall: 'In a call',
    onPhoneModalOptionVideoCall: 'In a video call',
    onPhoneModalOptionMeetingCall: 'In a meeting call',
    onPhoneModalSelectDuration: 'Duration',
    onPhoneModalConfirm: 'Confirm',
    onPhoneModalCancel: 'Cancel',
    onPhoneModalCloseAriaLabel: 'Close',
    onPhoneUntilEnd: 'On the phone until',
    // Out of Office modal
    oooModalTitle: 'Set Out of Office Status',
    oooModalReturnTime: 'Return time',
    oooModalReturnTimeIn1h: 'in 1h',
    oooModalReturnTimeIn1_5h: 'in 1.5h',
    oooModalReturnTimeIn2h: 'in 2h',
    oooModalReturnTimeIn2_5h: 'in 2.5h',
    oooModalReturnDate: 'Return date',
    oooModalReturnDateToday: 'Today',
    oooModalReturnDateSetDate: 'Set date',
    oooModalAbsenceComment: 'Absence comment',
    oooModalAbsenceOptionMeeting: 'In a meeting',
    oooModalAbsenceOptionCustomer: 'On site at the customer\'s premise',
    oooModalAbsenceOptionLunch: 'Lunch break',
    oooModalAbsenceOptionHolidays: 'OOO - on holidays',
    oooModalAbsenceOptionFreshAir: 'Stepping out for some fresh air',
    oooModalAbsenceOptionGrocery: 'Grocery shopping',
    oooModalAbsenceOptionMultiDayEvent: 'Multi-day event',
    oooModalAbsenceOptionOooVacation: 'On vacation',
    oooModalAbsenceOptionOooSabbatical: 'OOO - Sabbatical',
    oooModalAbsenceOptionOooParentalLeave: 'Parental leave',
    oooModalAbsenceOptionOooOutOfOffice: 'OOO - Out of office',
    oooModalAbsenceOption: 'Out of office',
    oooModalAbsenceHint: 'Select from list or type your own message',
    oooModalAbsenceMinCharsError: 'Custom comment must be at least 3 characters.',
    oooModalReturnTimePastError: 'Return time cannot be earlier than current time.',
    oooModalPreferredMethods: 'Preferred message receipt methods',
    oooModalPreferredEmail: 'Email',
    oooModalPreferredChat: 'Fluid Chat',
    oooModalConfirm: 'Confirm',
    oooModalCancel: 'Cancel',
    oooModalCloseAriaLabel: 'Close',
    cameraSettingErrorMessage:
        'An error occurred during the process of setting your device preferences. Please give it some time and try again. If the error repeats, contact help or the campus manager.',
    languageSelectionLabel: 'Select language',
    languageSelectionPlaceholder: 'Select a language',
    languageSelectionActionTitle: 'Language selection',
    languageSelectionDescription: 'CAMPUS will be displayed in German. Are you sure?',
    logoutTemporaryButton: 'Where to leave Campus',
    communicationSettings: 'Communication settings',

    // ProfileImageUploader page
    profileImageUploaderTitle: 'Upload image...',
    profileImageUploaderDescription: 'Drag and drop or click to select file.',
    profileImageUploaderDescription02: 'The file must not be larger than 2 MB.',
    profileImageUploaderUploadCapError: 'The size of the image you want to upload is larger than 2 megabytes.',

    // Help
    resetTutorialsActionTitle: 'Reset Tutorials',
    helpCentreActionTitle: 'Help Centre',
    reportErrorActionTitle: 'Report Error',
    dialogBoxTitle: 'Tutorials Reset',
    dialogBoxDescription: 'Please refresh the page to see the tutorials!',

    // General
    someone: 'Someone',
    dismissActionTitle: 'Dismiss',
    saveActionTitle: 'Save',
    saveChangesActionTitle: 'Save changes',
    savingActionLoadingTitle: 'Saving...',
    savingActionSuccessTitle: 'Saved!',
    creatingActionLoadingTitle: 'Creating...',
    processingRequestActionTitle: 'Processing your request...',
    changesSavedActionTitle: 'Changes saved',
    confirmActionTitle: 'Confirm',
    cancelActionTitle: 'Cancel',
    closeActionTitle: 'Close',
    refreshPageActionTitle: 'Refresh page',
    backgroundImageTitle: 'Background image',
    typeTitle: 'CAMPUS access for visitors',
    titleTitle: 'Title',
    calloutTitle: 'The title is visible at the visitor entrance',
    minimumCharacterLimitForTitle: 'The minimum character limit is 2',
    generalTitle: 'General',
    accessTitle: 'Access',
    editActionTitle: 'Edit',
    deleteActionTitle: 'Delete',
    clearActionTitle: 'Clear',
    submitActionTitle: 'Submit',
    meetActionTitle: 'Meet',
    finishActionTitle: 'Finish',
    okActionTitle: 'Ok',
    clearFilterActionTitle: 'Clear filter',
    reconnectToCampusActionTitle: 'Reconnect to CAMPUS',
    sendActionTitle: 'Send',
    skipActionTitle: 'Skip',
    skipActionTitleInCap: 'SKIP',
    startButtonLabelInCap: 'START',
    playActionTitle: 'Play',
    pauseActionTitle: 'Pause',
    downloadMicrosoftEdgeActionTitle: 'Download Microsoft Edge',
    enterActionTitle: 'Enter',
    talkingToMicrosoftActionTitle: 'Talking to Microsoft Identity Platform...',
    loadingTitle: 'Loading...',
    statusRestoring: 'Restoring status...',
    authenticatingTitle: 'Authenticating...',
    connectingTitle: 'Connecting...',
    loggedInto: 'You are currently logged into',
    yesAction: 'Yes',
    noAction: 'No',
    connectionLost: 'Connection lost',
    clientConnectionLostDescription1: 'The client lost connection to the server.',
    clientConnectionLostDescription2: 'This can have multiple reasons.',
    mobileActionTitle: 'Mobile',
    welcomeBack: 'Welcome back!',
    goodToSeeYouAgain: 'Good to see you again.',
    loadingText: 'Authenticating with ivicos identity services...',
    licenseNotActive: 'Your License does not seem to be activated.',
    errorAuthentication: 'There was an error with the authentication.',
    usersIn: 'Users in ',
    editMessageActionTitle: 'Edit message',
    previewActionTitle: 'Preview',
    addGifActionTitle: 'Add Gif',
    removeActionTitle: 'Remove',
    back: 'Back',
    of: 'of',
    discard: 'Discard',
    save: 'Save',
    cancel: 'Cancel',
    removeImage: 'Remove image',
    later: 'Later',
    writeUs: 'Write us',
    talkToSales: 'Talk to sales',
    benefitsMissing: 'Benefits you’ll miss…',
    campusRestored: 'Your Campus has been successfully restored!',
    // visitor landing page
    landingPageEnterName: 'Please enter your name here',
    landingPageEnterNameCallOutPart1: 'Please enter your name, a nickname, or pseudonym.',
    landingPageEnterNameCallOutPart2: 'This information will not be stored in our system and will be deleted as soon as you leave CAMPUS.',
    landingPagePrivacyHint: 'Privacy hints: click question-mark.',
    landingPageGoIn: 'Go in',
    landingPageAudioCallOut: 'This display is for testing the local microphone activation. No data is transmitted anywhere.',
    landingPageSetAudioDevices: 'Set Audio Devices',
    landingPageRisk: 'Risk of cumbersome handling with your current browser.',
    landingPageWeRecommend: 'We recommend:',
    landingPageRiskCallOutPart1: 'Some Browsers can be tricky as they are not all following the same standards and sometimes generate incompatibilities.',
    landingPageRiskCallOutPart2: 'For this reason, we cannot recommend the use of Safari or Firefox at the moment.',
    landingPageHeaderTitle: 'Audio & Video Settings',

    // waitingArea
    waitingAreaHelloVisitor: 'Hello',
    waitingAreaWaitBriefly: 'Please wait briefly:',
    waitingAreaHostInformed: 'your host has just been informed of your arrival.',
    waitingAreaNoOneGreet: 'No one seems to have come to greet you:',
    waitingAreaClickAgain: 'Please click the button with the bell below to send a further notification of your presence.',
    waitingAreaNotifyHost: 'Notify Host',

    // invalid invitation link
    insertedLinkIncorrect: 'The inserted link appears to be incorrect or incomplete!',
    verifyAccuracyOfInvitationLink: 'Please verify its accuracy and copy it back into a browser tab.',
    invalidInvitationProblemPersists: 'If this problem persists, contact our support service ',
    supportServiceHere: 'here',

    // Campus Settings
    lobbyImageTitle: 'Lobby background image',
    changeColorActionTitle: 'Change color',
    changeLogoActionTitle: 'Change logo',
    changeImageActionTitle: 'Change image',
    changeImageCalloutTitle: 'This image will appear in the background of your visitor entrance. The file size must be up to 2 MB.',
    changeLobbyBgImageTitle: 'This image will appear in the lobby background. The file size must be up to 2 MB.',
    visitorEntranceYTTitle: 'Video for the waiting room',
    instructionToSetVideoAtVisitorEntrance:
        'Set a video here that guests can watch when waiting for a person in the guest reception. The video appears in the guest reception unless a different video is set when creating an access authorization.',
    pasteYTVideo: 'Paste a YouTube video link here',
    changeYTVideo: 'Change video',
    selectYTVideo: 'Select video',
    changeColorCalloutTitle: 'This will determine your branding color and will be displayed especially in the header of your CAMPUS',
    changeLogoCalloutTitle:
        'The logo will appear on your top bar, in your waiting area, and when inviting colleagues to your CAMPUS. The maximum size shoud be 250 x 100 and 2 MB',
    ownershipTitle: 'Ownership',
    transferOwnershipActionTitle: 'Transfer ownership',
    transferActionTitle: 'Transfer ownership',
    transferOwnershipError:
        'Some error occurred during the process of transferring ownership. Please try to transfer ownership again and if the error is repeated contact the responsible person.',
    transferOwnerShipDescriptionTitle:
        'When transferring ownership you will no longer be the owner and, if applicable, the creditor of this CAMPUS. Please be aware of this before transferring!',
    currentManagersListTitle: 'List of current managers',
    searchManagersPlaceholder: 'Search managers',
    managerDetailsListTitle: 'Details of managers',
    transferOwnershipWarningTitle1: 'Clicking confirm changes ownership rights to ',
    transferOwnershipWarningTitle2: ' and you will become a manager.',
    brandIdentityTitle: 'Brand identity',
    campusDesignTitle: 'CAMPUS design',
    visitorEntranceDesignTitle: 'Visitor entrance design',
    campusNameTitle: 'Campus name',
    campusColorTitle: 'Color',
    campusLogoTitle: 'Logo',
    saveCampusSettingsDescription: 'Clicking confirm will save any changes you just made on your CAMPUS settings.',
    accessMethodTitle: 'Access method',
    switchOnDescription: 'Switch on MS active directory sync for all CAMPUS members.',
    switchOffDescription: 'Everyone from your Microsoft organisation is asked to join this CAMPUS on sign-up.',
    accessMethodCallout1: 'You can link your CAMPUS to your Microsoft organisation.',
    accessMethodCallout2: 'This way everyone in your Microsoft organisation will be asked to join this CAMPUS on sign-up.',
    confirmDescription: 'Are you sure?',
    OwnershipTransferredActionTitle: 'Ownership transferred',
    signOutAndSignInError: 'Please sign out from the CAMPUS and then sign in again to implement the changes.',
    errorOccurred: 'Error occurred',
    removeOrganizationButton: 'Remove organisation',
    removeOrganizationChoiceAccept: 'Yes, I am sure',
    removeOrganizationChoiceRefuse: 'No, I do not want to remove it',
    removeOrganizationQuestion: 'Are you sure you want to remove [org]?',
    removeOrganizationExplanation: 'This means that all members, areas, rooms and documents created on the Campus of this organisation will be lost.',
    removeOrganizationModalTitle: 'Remove organisation',
    isSavingChanges: 'Saving changes...',
    externalDoorsTitle: 'Opening hours',
    externalDoorsAdminCenterTitle: 'Admin center to manage third party access to this Campus',
    externalDoorsCurrentDateTime: 'It\'s [date] – [time]h',
    externalDoorsCreateEditAccessPassesTitle: 'Create/edit access',
    externalDoorsSecurityLevels: 'with different security levels',
    externalDoorsAccessMethods: 'access methods (pickup, direct)',
    externalDoorsBankHolidays: 'considering bank holidays and or',
    externalDoorsOpeningHours: 'organizational opening hours.',
    externalDoorsCreateEditExteriorDoorsButton: 'Create or edit access',
    externalDoorsOverviewTitle: 'An overview of existing accesses',
    externalDoorsOverviewSecurityComfort: 'allowing to ensure they match the desired security and comfort for users',
    externalDoorsOverviewControl: 'to maintain control also in case of plenty accesses for externals.',
    externalDoorsEnterControlRoomButton: 'Access cockpit',

    // Auth
    loginPromptTitle: 'Identification, please!',
    loginPromptDescription: 'Sign in with your company-issued Microsoft account...',

    // Notifications
    meetNotificationActionTitle: 'Meet',
    inviteNotificationActionTitle: 'Invite',
    acceptNotificationActionTitle: 'Accept',
    answerNotificationTitle: 'Answer',
    doorKnockNotificationBody: 'Do you want to invite them in?',
    doorKnockConfirmationNotificationBody: 'You have knocked at the door of the room: {roomName}!',
    memoSentNotificationBody: 'The person has been notified',
    noUsersWarning: 'There is no one here to announce something to',
    showDetailsActionTitle: 'Show details',
    meetThemActionTitle: 'Meet them',
    visitorIsWaitingNotificationTitle: 'is at the door!',
    visitorIsWaitingNotificationBody: 'Do you want to meet them?',
    visitorFor: 'For: ',
    visitorHost: 'Host: ',
    visitorIsWith: ' is at the visitor entrance with ',
    visitorWithOthers: ' and others are with ',
    memoSentToNotificationActionTitle: 'Memo sent to ',
    somethingWentWrongNotificationActionTitle: 'Something went wrong',
    invitationSentNotificationActionTitle: 'Invitation sent!',
    inputSupportsMarkdownTitle: 'This input supports markdown (click to find out more)',
    inviteVisitorNotificationBody: 'Do you want to join them?',
    youHaveTheGuestMessage: 'You have a guest!',
    successMessage: 'Success!',
    inviteYouToMessage: 'invites you to',
    inviteYouToMessage1: 'invites you to his/her personal room',
    invitedYouToMessage: 'invited you to',
    invitedYouToMessage1: 'invited you to his/her personal room',
    inviteYouToMessage2: '',
    saysMessage: 'says:',
    saidMessage: 'said:',
    isAtYourDoorMessage: 'is at the door',
    wasAtYourDoorMessage: 'was at the door',
    someoneMessage: 'Someone',
    replyActionTitle: 'Reply',
    inviteThemInActionTitle: 'Invite them in',
    acceptInvitationActionTitle: 'Accept invitation',
    userAlreadyExists: 'User already exists',
    sendMemoToActionTitle: 'Send memo to',

    // Grouped Notifications
    closeAllMemosAndInvitations: 'Close all memos and invitations',
    closeAllMemos: 'Close all memos',
    closeAllInvitations: 'Close all invitations',
    closeAllVisitorNotifications: 'Close all visitor notifications',
    closeAllMessages: 'Close all messages',
    closeAllMessageDialogSubText1: 'If you close this window, you will lose all your ',
    onlyMemos: 'memos',
    onlyInvitations: 'invitations',
    memosAndInvitations: 'memos and invitations',
    onlyVisitorNotifications: 'visitor notifications',
    onlyMessages: 'messages',
    closeAllMessageDialogSubText2: 'Are you sure?',
    closeAllMessageDialogNo: 'No',
    closeAllMessageDialogYes: 'Yes',
    seekingAttention: 'is seeking your attention!',
    wasSeekingAttention: 'was seeking your attention!',
    thereAreVisitors: 'Someone is at the visitor entrance!',
    youHave: 'You have ',
    unreadMemos: 'unread memo(s) ',
    notificationDescriptionAnd: 'and ',
    ignoredInvitations: 'ignored invitation(s).',
    visitorsWaiting: ' visitors waiting.',
    viewAll: 'View all',
    hideAll: 'Hide all',
    closeAll: 'Close all',

    //User Actions
    inviteUserToRoomActionTitle: 'Invite to your room',
    sendUserMemoActionTitle: 'Send memo',
    kickOutVisitorActionTitle: 'Remove visitor from CAMPUS',
    redirectUserActionTitle: 'Redirect this {userOrVisitor} to their personal room',
    inAMeetingActionTitle: 'In a meeting',
    userIsInAMeetingActionTitle: '{User} is in a meeting!',
    userIsInAMeetingActionText: 'Do you still want to send a memo to {User}?',
    redirectUserModal: {
        title: 'Do you really want to remove {username} from your personal room?',
        text1: 'That might be perceived as impolite.',
        text2: 'FYI - The user will receive a message that you have done this.',
        yes: 'Yes',
        no: 'No',
        confirmationText: '{username} has been successfully removed from your personal room.',
        errorText: 'Something went wrong. Please try again.',
        closeButton: 'Close',
        informationModal: {
            title: '{username} has accompanied you out of his personal room.',
            text: 'Please do not interpret this as an impolite gesture. {username} simply wanted to use his personal office alone again.'
        }
    },

    // Sidebar
    personalRoomsSectionTitle: 'Personal rooms',
    commonRoomsSectionTitle: 'Rooms',
    commonRoomsSectionEmptyNoticeTitle: 'No rooms on this floor',
    commonRoomsSectionEmptyNotice: 'You can add rooms below.',

    // Member Invites
    inviteMemberLabelTitle: 'to this organization',
    inviteAnyoneLabelTitle: 'from outside',
    inviteMemberLabel: 'Invite member',
    inviteMemberPlaceholder: 'Email address',
    inviteMemberErrorMessage: 'Invalid email address',
    InviteRoleErrorMessage: ' is not valid, please select user or manager',
    inviteLanguageErrorMessage: ' is not valid, please select English or Deutsch',
    inviteMemberDescription1:
        'This is a single member invite. After sending the invite the person will be notified via email and will appear on the members list.',
    inviteMemberDescription2:
        'Use a .csv file to upload multiple members at one time. After transfering the invite list the people will be alerted via email and will appear on the members list.',
    ImportCSVFileTitle1: 'Import CSV File',
    ImportCSVFileTitle2: 'Revising invitations',
    ImportCSVFileTitle3: 'Inviting...',
    ImportCSVFilePlaceholder: 'Drag and drop a .csv file here, or click to select a file.',
    downloadCSVTemplateFileLabel: 'Download .CSV template file',
    changeFileActionTitle: 'Change file',
    inviteThesePeopleActionTitle: 'Invite these people',
    inviteThesePeopleConfirmDescription: 'Are you sure you want to invite these people?',
    emailTitleLabel: 'Email address',
    emailTitlePlaceholder: 'Type in a work email address',
    roleTitleLabel: 'Role',
    languageTitleLabel: 'Language',
    rolePlaceHolder: 'Choose a role',
    inviteSingleUserTitle: 'Add a single member',
    inviteMultipleUserTitle: 'Add multiple members',
    bulkInviteDescription1: 'A bulk invitation is generated via a ',
    bulkInviteDescription2: ' file containing the email addresses of all invited members. The new member will automatically appear on the members list.',
    sendInviteButtonTitle: 'Send invite',
    sendInvitesButtonTitle: 'Send invites',
    openBulkInviteButtonTitle: 'Open bulk invite',
    confirmBulkInviteQuestion1: 'Are you sure you want to send these member invites?',
    confirmBulkInviteQuestion2: 'Are you sure you want to send this member invite?',
    bulkInviteStep1Title: 'Step one:',
    bulkInviteStep2Title: 'Step two:',
    bulkInviteStep1Description: 'Download the template file and fill it in with the email addresses of the member you intend to add to your CAMPUS.',
    bulkInviteStep2Description: 'Once completed, upload it to the box below to proceed with the bulk invitation.',
    invitationAlreadySent: 'Invitation already sent',
    successfullyInvited: 'Successfully invited!',
    inactiveAccountInvited: 'Inactive account',
    invitedSponsorTooltipYourList: 'The person is included in your billing list',
    invitedSponsorTooltipOtherList: 'The person is on another billing list',

    // Invitations
    createInvitationTitle: 'Create new invitation',
    createInvitationButtonTitle: 'Create new invitation',
    inviteMemberActionTitle: 'Invite member',
    bulkInviteActionTitle: 'Bulk invite',
    resendInvitationActionTitle: 'Resend invitation?',
    resendInvitationActionDescription: 'Are you sure you want to resend the invitation to ',
    reviewInvitationTitle: 'Review invitations',
    reviewInvitationDescription1: 'One or more people could not be invited as they have no active account.',
    reviewInvitationDescription2: 'However, their invitations can be reworked at any time by filtering the table by Inactive.',
    reviewInvitationClose: 'Close',
    deleteInvitationActionTitle: 'Delete invitation',
    deleteInvitationActionTitle2: 'Delete invitation',
    deleteInvitationActionDescription: 'Are you sure you want to delete this user?',
    invitationsManagerTitle: 'Invitations manager',
    invitationsTitle: 'Invitations',
    waitingVisitorsTitle: 'Waiting visitors',
    filterInvitationsPlaceholder: 'Filter invitations',
    upcomingInvitationsTitle: 'Upcoming invitations',
    recurringInvitationsTitle: 'Recurring invitations',
    showExpiredInvitationsActionTitle: 'Show expired',
    noVisitorsDescriptionTitle: 'There are no visitors at the moment',
    areaTitle: 'Area',
    roomTitle: 'Room',
    hostsTitle: 'Host(s)',
    welcomeMessageTitle: 'Welcome message',
    missingWelcomeMessageTitle: 'No welcome message entered.',
    validityTitle: 'Validity',
    validTitle: 'Valid',
    validFromTitle: 'valid from',
    onTitle: 'On',
    selectedHostTitle: 'Selected host',
    hostSelectorDescription: 'Hosts will be notified of the arrival of a visitor.',
    hostSelectorPlaceholder: 'Start typing names to add other hosts',
    invitationValidityCallout: 'Single invitations are valid for the date specified below while recurring invitations are repeated on a specified frequency.',
    invitationTypeCallout:
        'In the case of a direct link, visitors will be able to enter directly a specified room, whereas in the case of a pick up link, visitors will have to be picked up by a host in the waiting area.',
    invitationDeleteConfirm: 'Are you sure you want to delete this invitation link?',
    eventTypeSingle: 'Single',
    eventTypeRecurring: 'Recurring',
    InvitationTypeDirect: 'Direct',
    InvitationTypePickup: 'Pick up',
    RecurringTypeEveryDay: 'Every day',
    RecurringTypeEveryWeek: 'Every week',
    invitationDeleteConfirm2: 'Are you sure you want to delete',
    copyFailedActionTitle: 'Copy failed',
    copyActionTitle: 'Copy',
    copiedActionTitle: 'Copied!',
    manageAccessTitles: 'Manage access',
    msEnabledTitle: 'MS ACTIVE DIRECTORY: enabled',
    suggestionsHeaderText: 'Suggested People',
    mostRecentlyUsedHeaderText: 'Suggested Contacts',
    noResultsFoundText: 'No results found',
    loadingTitleText: 'Loading',
    suggestionsAvailableAlertText: 'People Picker Suggestions available',
    suggestionsContainerAriaLabel: 'Suggested contacts',
    invitationSendButtonText: 'Submit',
    invitationEmailSubject: 'You have an access invitation to the Campus from {orgName}',
    invitationEmailBody: `Title: {invName}%0D%0A
    %0D%0AValidity: {frequency} from {validFromTime} to {validToTime}%0D%0A
    %0D%0AAccess link: {invitationLink}%0D%0A
    %0D%0A
    %0D%0A===================================================%0D%0A
    %0D%0A
    %0D%0ALearn more about ivCAMPUS: https://ivicos.eu%0D%0A
    `,
    createAndContinue: 'Create and continue',
    updateInviationTitle: 'Your invitation is ready and looks like this:',
    editCustomUrlTitle: 'Link preview',
    editCustomUrl: 'Customize ending',
    customUrlCallout:
        'Here, the ending of the invitation’s link can be changed as desired. For example, the title of an event or the name of a person to be invited can be used. Please do not use any special characters.',
    calendarIntegrationTitle: 'You can also choose between the following options:',
    calendarIntegrationButton: 'Add to calendar and/or download .ics file',
    invitationToEmailButton: 'Send to e-mail address(es)',
    downloadInvitation: 'Download .ics file',

    // Custom Url Modal
    customUrlModalTitle: 'Modify link appearance',
    customUrlModalDescription1:
        'Here you can change the appearance of your invitation link as you wish, e.g. with the title of the event, or with the name of the person you wish to invite. Closing or pressing discard will still save the invitation with the default link.',
    customUrlModalDescription2: 'Please don’t use special characters.',
    customUrlModalErrorNoSpecialCharacters: 'Special characters cannot be used!',
    customUrlModalErrorMaximumLimit: 'The maximum character limit is 50!',
    customUrlModalErrorMinimumLimit: 'The minimum character limit is 1!',
    customUrlModalErrorCustomUrlExists: 'This link already exists!',
    customUrlModalLinkAppearance: 'Link preview:',
    customUrlModalDiscard: 'Discard',
    customUrlModalSaveAndCopy: 'Save and copy',

    // Customized video url
    customizedVideoLabel: 'Use default video for the waiting room',
    customizedVideoCallOutPart1: 'This video is offered to guests for viewing when waiting for a pick-up in the guest reception.',
    customizedVideoCallOutPart2: 'The video replaces the video set as default in the CAMPUS settings.',
    customizedVideoOn: 'On',
    customizedVideoOff: 'Off',
    customizedVideoPasteLink: 'Paste YouTube link',

    // Visitors
    visitorTabTitle: 'Visitors',
    visitorEntranceTitle: 'Visitor entrance',
    farewellMessageTitle: 'Farewell message',
    farewellMessageCallout:
        'All CAMPUS visitors can be manually dismissed with a simple click while hovering on their badge. To accompany their departure, it is possible to choose a farewell message that will appear once they have left.',
    visitorLinkTitle: 'Your invitation link',
    visitorLinkDescription: 'Share this link to invite people to this floor. You will get notified when you have a visitor and they will show up below.',
    copyButtonLabel: 'Copy invitation link to clipboard',
    copyButtonSuccessLabel: 'Link copied!',
    copyButtonErrorLabel: 'Error :(',
    letVisitorInsideActionTitle: 'Let them inside',
    letVisitorInActionTitle: 'Guide them inside',
    meetVisitorActionTitle: 'Meet',
    dialogYourInvitationSent: 'Your invitation has been sent! It might take up to 5 minutes to receive it.',
    dialogPersonNotAddedToBillingList1: 'Note: The person you invited has an active account and will therefore not be added to ',
    dialogPersonNotAddedToBillingList2: '´s billing list.',
    dialogPersonDoesNotHaveActiveAccountTitle: 'Inactive account',
    dialogPersonDoesNotHaveActiveAccount1: 'The person you want to invite does not have an active user account.',
    dialogPersonDoesNotHaveActiveAccount2: 'Would you like to add this person to your organization?',
    dialogWeDidNotSendInvitationTitle: 'Invitation was not sent!',
    dialogPersonDoesNotHaveActiveAccount3: 'We have not sent an invitation because the user is not yet registered on ivCAMPUS.',
    dialogPersonDoesNotHaveActiveAccount4:
        'Please ask this person, who should not be assigned to your organisation, to create their own CAMPUS for their organisation. As soon as they are registered on the platform, they can be invited to your campus.',
    dialogPersonDoesNotHaveActiveAccountNo: 'No',
    dialogPersonDoesNotHaveActiveAccountYes: 'Yes',
    dialogIsAlreadyAMember: ' is already a member',
    notActiveMessageDaily: 'Your invitation with the title "{eventName}" is valid everyday from {timeFrom} to {timeTo}.',
    notActiveMessageWeekly: 'Your invitation with the title "{eventName}" is valid every week from {dayFrom} at {timeFrom} to {dayTo} at {timeTo}.',
    notActiveMessageSingle: 'Your invitation with the title "{eventName}" is valid from {completeDateFrom} to {completeDateTo}.',
    youAreTalkingTo: 'You are talking to',
    directVisitorToRoom: 'Guide visitor to...',
    thanksForVisitMessage: 'Thank you for your visit!',
    VisitorExitDescription1: 'Your visit was enabled by ivicos CAMPUS.',
    VisitorExitDescription2: 'Learn more at',
    VisitorExitDescription3: 'ivicos.eu',
    invitationLinkNotValid: 'The visitor entrance is currently closed. Therefore, the link does not lead any further.',
    errorInButton: 'Error',
    backToAreaButton: 'Back to area',
    roomIsOccupied: 'is currently occupied',
    manageEntranceButton: 'Guide visitor to...',

    // Area Actions / Navigator
    addAreaActionTitle: 'Area',
    addAnAreaActionTitle: 'add new area',
    addAreaGroupActionTitle: 'add new area group',
    editAreaActionTitle: 'Edit Area',
    editAreaGroupActionTitle: 'Edit Area Group',
    deleteAreaActionTitle: 'Delete Area',
    deleteAreaGroupActionTitle: 'Delete Area Group',
    searchAreasPlaceholder: 'Filter areas',
    createAreaTitle: 'Create new area',
    createAreaGroupTitle: 'Create new area group',
    enterAreaNameLabel: 'Area name',
    enterAreaTagLabel: 'Area title',
    enterAreaGroupNameLabel: 'Area group name',
    enterAreaGroupTagLabel: 'Area group title',
    enterAreaNamePlaceholder: 'Type new area name',
    enterAreaGroupNamePlaceholder: 'Type new area group name',
    enterAreaTagPlaceholder: 'Type new area title',
    enterAreaGroupTagPlaceholder: 'Type new area group title',
    enterAreaSortNumberLabel: 'Sort order (0–1000)',
    enterAreaGroupSortNumberLabel: 'Sort order (0–1000)',
    enterAreaSortNumberPlaceholder: '0–1000',
    enterAreaGroupSortNumberPlaceholder: '0–1000',
    enterAreaSortNumberError: 'Enter a whole number from 0 to 1000.',
    areaPreview: 'Preview',
    deleteAreaDescription: 'Are you sure you want to delete',
    areaLeaveConfirmDescription: 'Are you sure you want to leave this area?',
    panelTitle: 'Navigator',
    showMoreOptionsTooltip: 'Show more options',
    maxFavoriteAreasReached:{
        title: 'Maximum selection of favourite areas reached.',
        description: 'You can only select 2 favourite areas as shortcut for display in the navigation bar. Click on a filled-in star icon to deselect a favorite area and then click on this star again to mark this area as a favourite one.',
        close: 'Close hint'
    },
    allAreasDeletedPart1: 'All areas with rooms have been deleted!',
    allAreasDeletedPart2: 'You can now add new areas here.',

    // Area Actions / Search Person
    crossAreaSearchPersonIconTitle: 'Search person',
    crossAreaSearchPersonPanelHeaderTitle: 'Search person',
    crossAreaSearchPersonPanelCloseButton: 'Close',
    crossAreaSearchPersonSearchBarPlaceholder: 'Search',
    crossAreaSearchPersonThisArea: 'this area',
    crossAreaSearchPersonOtherArea: 'other area (this campus)',
    crossAreaSearchPersonDashboard: 'lobby',
    crossAreaSearchPersonOutOfOffice: 'Out Of Office',
    crossAreaSearchPersonNotFound: 'No results were found for the entered search term',

    // Room Actions
    enterRoomActionTitle: 'Enter room',
    knockOnDoorActionTitle: 'Knock on door',
    editRoomActionTitle: 'Edit room',
    sendMemoIntoRoomActionTitle: 'Send memo into room',
    roomSettingsActionTitle: 'Room setup',
    createNewRoomActionTitle: 'Create new room',
    createNewRoomActionLoadingTitle: 'Creating new room...',
    deleteRoomActionTitle: 'Archive room',
    deleteRoomActionLoadingTitle: 'Archiving...',
    deleteRoomActionConfirmationTitle: 'Room archived.',
    NoRoomAvailableDescription: 'No room is available in this area',
    memoPlaceholder: 'Type your message...',
    mobileDescription1: 'Scan this code with your phone',
    mobileDescription2: 'To join the room',
    sendMemoToVisitor: 'Send memo',
    sendHostMemo: 'Send host a memo',

    // Room settings
    roomSettingsPanelTitle: 'Room setup',
    roomNameInputLabel: 'Room name',
    roomNameInputPlaceholder: 'Untitled Room',
    iconPickerLabel: 'Room Icon',
    privacySectionLabel: 'Privacy',
    openToVisitorsCheckBoxLabel: 'Open to external visitors',
    openToVisitorsCheckBoxDescription:
        'Visitors invited by CAMPUS members may enter this room. This room is marked separately with this symbol. However, only when visitors are on Campus.',
    confirmDeletePromptLabel: 'Are you sure you want to delete this room from CAMPUS?',
    audioOnlyCheckBoxLabel: 'Disable video in this room',
    audioOnlyCheckBoxDescription: 'Conversations in this room are audio only if this option is set',
    whitelistSelectorLabel: 'Whitelist',
    whitelistSelectorPlaceholder: 'Start typing names to add users to the whitelist...',
    whitelistSelectorDescription: '',
    toggleWhitelistLabel: 'Allow access for only selected users',
    toggleWhitelistDescription: '',
    dismissAction: 'dismiss',
    deleteAction: 'delete',
    noneAction: 'none',
    deletionAction: 'deletion',
    updateAction: 'update',
    deleteQuestion1: 'Are you sure?',
    deleteQuestion2: 'Discard unsaved changes?',
    deleteQuestion3: 'Archived rooms will become unavailable to all users...',
    deleteQuestion4: 'You have made changes to this room that have not been saved yet... do you want to discard them?',
    setTopicTitle: 'Set topic',
    setATopicDialogBoxTitle: 'Set a topic ',

    //Call view
    deviceSettingsActionTitle: 'Device settings',
    toggleVideoActionTitle: 'Toggle camera',
    toggleAudioActionTitle: 'Toggle microphone',
    toggleAttachment: 'Toggle Attachments',
    toggleLinkAttachment: 'Toggle Link Attachments',
    toggleToolAttachment: 'Toggle Tool Attachments',
    safariNotSupported: 'This feature is currently not supported in safari',
    toggleTileViewActionTitle: 'Toggle tile view',
    shareScreenActionTitle: 'Share screen',
    shareScreenActionActiveTitle: 'Stop sharing screen',
    toggleEncryptionActionTitle: 'Toggle encryption (experimental)',
    toggleEncryptionActionActiveTitle: 'Encryption is enabled (BETA)',
    raiseHandActionTitle: 'Raise hand',
    unraiseHandActionTitle: 'Tap "Done" to lower your hand',
    unraiseHandActionButtonTitle: 'Done',
    toggleBackgroundDialogActionTitle: 'Set my video background',
    leaveRoomActionTitle: 'Back to personal room',
    toggleStatsActionTitle: 'Toggle Virtual Moderator',
    encryptionIsEnabledLabel: 'End-to-end encrypted',
    connectedToLabel1: 'Securely connected to',
    connectedToLabel2: 'CAMPUS platform',
    connectedToLabel3: 'Powered by IONOS Cloud ',
    // eslint-disable-next-line quotes
    personalRoomTitle: "'s personal room",
    // eslint-disable-next-line quotes
    personalRoomHelper: "'s personal",
    // eslint-disable-next-line quotes
    personalRoomTitleForNameEndingWithS: "s's personal room",
    unknownPersonalRoomTitle: 'A personal room',
    callLoadingScreenLabel: 'Connecting to secure server...',
    callLoadingScreenDescription: 'Please wait, while we establish a connection with one of our secure servers in Europe.',
    changeCallAudioAndVideo: 'You can change your audio and video settings here.',
    callRetryMessage: 'If this takes longer than expected retry',
    PleaseStandByMessage: 'Please stand by.',
    announcingArrival: 'We are announcing your arrival...',
    retryActionTitle: 'Retry',
    safariRoomCallDescription:
        'Safari disallows cross-site tracking by default by disabling third-party cookies and cross-site localStorage. So you would not be able to access etherpad unless you disable it manually by following below mentioned steps.',
    safariRoomCallDescriptionStep1:
        '1. Open Safari Preferences, by clicking on the `Safari` menu on the left of the menu bar, and clicking on`Preferences`, or by pressing `⌘,`.',
    safariRoomCallDescriptionStep2: '2. Click on the `Privacy` tab.',
    safariRoomCallDescriptionStep3: '3. Uncheck the `Prevent cross-site tracking` check box.',
    waitingAreaTitle: 'Visitor entrance',
    videoCallTitle: 'Video call',
    setATopicActionTitle: 'Set topic',
    alertMessageWhileScreenShareIsActive: 'Stop screen sharing to return to your personal room',
    callActionButtonSelectBackground: 'Select background',

    // Device settings
    audioSettingsTitle: 'Audio settings',
    videoSettingsTitle: 'Video settings',
    audioInputDeviceTitle: 'Audio input device',
    audioOutputDevice: 'Audio output device',
    videoDeviceTitle: 'Video device',
    selectDevicePlaceholder: 'Select device',

    // Portal
    availableAreasTitle: 'Areas',
    manageAccessTitle: 'Members',
    campusSettingsTitle: 'CAMPUS settings',
    billingTitle: 'Billing',
    addAreaToTabBarActionTitle: 'Display area on tab bar',
    // eslint-disable-next-line quotes
    removeAreaFromTabBarActionTitle: "Don't display area on tab bar",
    changeLogTitle: 'Changelog',
    areaOpenToEveryoneLabel: 'Open to all members',

    // Members
    filterMembersPlaceholder: 'Filter members',
    emailColumnTitle: 'Email',
    nameColumnTitle: 'Name',
    roleColumnTitle: 'Role',
    pendingInviteTitle: 'Invite pending...',

    // Roles
    userRoleTitle: 'user',
    managerRoleTitle: 'manager',
    userRoleTitleInCap: 'User',
    managerRoleTitleInCap: 'Manager',
    ownerRoleTitle: 'Owner',
    inviteeRoleTitle: 'Invited',
    inactiveInviteeRoleTitle: 'Inactive',

    // Language
    englishLanguageTitle: 'English',
    deutschLanguageTitle: 'Deutsch',

    //Alerts
    generalAlertTitle: 'Warning',
    webSocketAlert: 'We are unable to connect you to the web socket. Please try again.',
    connectionTimedOut: 'Your connection timed out.',
    safariDetection: 'Sadly CAMPUS does not support the Safari browser at the moment :/ We recommend using Edge or Chrome',
    mobileDetection: 'Sadly CAMPUS does not support mobile view at the moment :/ We recommend using a computer',
    invalidDataAlert: 'Invalid data',
    yeetAlert: 'yeet',
    browserNotSupportAlert: 'This browser does not support desktop notifications.',
    errorConnectingAlert: 'There was an error with your connection... press ok to reconnect.',
    connectionLostMessage: 'Connection lost!',
    lostConnectionMessage: 'You seem to have lost connection to the internet.',
    clickToReconnectMessage: 'Please click the button below after you have reestablished a connection.',
    firefoxAlert: 'Firefox Screen Sharing: Please click anywhere on the video frame below before attempting to share your screen',
    reconnectToMicrosoft: 'Reconnecting to Microsoft Services... ',
    trialPeriodExpiredTitle: 'Trial Period Expired',
    trialPeriodExpiredContent: 'The trial period of [org] has ended.',
    trialPeriodExpiredContactSalesTeam1: 'Your Campus is currently not accessible anymore. Please contact our team at ',
    trialPeriodExpiredContactSalesTeam2: ' now and they’ll be happy to provide access to your rooms and areas again.',
    trialPeriodExpiredContactSalesTeam3: 'Alternatively, you can click the button below and it will open your standard email application.',
    trialPeriodExpiredUserContent:
        'The trial period of [org] has ended. No further agreement has been made for your organization yet. Please contact the sales department. They will be happy to assist you.',
    trialPeriodExpiredChoiceTitle: 'Choose an action',
    trialPeriodExpiredChoiceAccept: 'Make a subscription',
    trialPeriodExpiredChoiceRefuse: 'Remove current Campus and start a new trial period',
    makeSubscriptionTitle: 'Make a subscription',
    makeSubscriptionContent: 'To make a subscription, we need some additional details',
    subscriptionFieldCompanyName: 'Company name',
    subscriptionFieldPostalCode: 'Postal code',
    subscriptionFieldAddress: 'Address',
    subscriptionFieldAddressPlaceholder: 'Street and Number',
    subscriptionFieldCityPlaceholder: 'City',
    subscriptionFieldCity: 'Town/City',
    subscriptionFieldCountryCode: 'Country code',
    subscriptionFieldVatNumber: 'VAT number',
    trialPeriodAboutToExpireTitle: 'The trial period will end soon!',
    trialPeriodAboutToExpireDaysLeft: 'There are [count] days left until the end of the trial period, after which [org] will be removed',
    trialPeriodAboutToExpireQuestion: 'Would you like to continue using this Campus? Please get in touch with sales now.',
    billingActiveDirectTitle: 'Usage agreement with ivicos GmbH',
    billingActiveDirectDescription: 'This CAMPUS is directly invoiced to ivicos GmbH. If you have any questions, please contact our team at ',
    billingActiveDirectAlternative: 'Alternatively, you can click the button below and it will open your default email application.',

    // Tooltips
    announcementTitle: 'Announce something...',
    areaSwitchTitle: 'Back to the Lobby / Display available areas',
    togglePanelTitle: 'Toggle panel',
    backToDashboardTitle: 'Back to the lobby',
    openForVisitorsTitle: 'The room is open to visitors',
    roomOptionsTitle: 'Room options',
    noAccessToRoom: 'A special access authorization is required for this room',
    areaPresenceTooltip: {
        membersOnly: 'In this area there {verb} {count} {members}',
        visitorsOnly: 'In this area there {verb} {count} {visitors}',
        bothPresent: 'In this area there {verb} {memberCount} {members} and {visitorCount} {visitors}',
        member: 'member',
        members: 'members',
        visitor: 'visitor',
        visitors: 'visitors',
        is: 'is',
        are: 'are'
    },

    // Attachments
    toggleAttachmentsActionTitle: 'Toggle file list',
    attachmentPanelTitleLinks: 'Links',
    attachmentPanelTitleTools: 'Tools',
    videoOwnerTransferModalTitle: 'Video Playback Control',
    videoOwnerTransferModalSentence1: 'You are about to transfer control of video playback to',
    videoOwnerTransferModalSentence2: 'Are you sure you want to continue?',
    videoOwnerTransferModalCancelButtonLabel: 'Cancel',
    videoOwnerTransferModalTransferButtonLabel: 'Transfer',
    videoOwnershipTransferredToLocalUserModalSentence1Part1: 'You have been elected controller of the video by ',
    videoOwnershipTransferredToLocalUserModalSentence1Part2: ' and are now responsible for its playback. ',
    videoOwnershipTransferredToLocalUserModalSentence2: 'If you leave the room for any other reason, you can appoint another person to control video playback.',
    videoOwnershipTransferredToLocalUserModalOkButtonLabel: 'Ok',
    videoControlPanelTitle: 'Video Playing',
    videoControlPanelPlaybackControlledByTitle: 'Controlled By',
    videoControlPanelTransferPlaybackControlTitle: 'Transfer video control playback to',
    pinnedAttachmentPanelTitle: 'Pinned Attachment',
    createNewAttachmentActionTitle: 'Create new file',
    filterAttachmentsPlaceholder: 'Filter files...',
    savedItemTitle: 'Saved items',
    noAttachmentsWarning: 'No files in this room, yet.',
    noAttachmentsHelperText: 'Files shared in this room will appear here',
    chooseAttachmentTypeTitle: 'Choose tool type...',
    createLinkAttachmentTitle: 'Create a new link',
    createToolAttachmentTitle: 'Create a new tool',
    linkTypeTitle: 'Link',
    collaboardTypeTitle: 'Collaboard',
    collaboardTypeDescription: 'Real-time collaboration tool',
    collaboardLinkAttachmentModalBoxTitle: 'Create new Collaboard project attachment',
    colleboardLinkAttachmentModalBoxSubText: 'Please enter (or paste) a link to a Collaboard project',
    conceptboardTypeTitle: 'Conceptboard',
    conceptboardTypeDescription: 'Real-time collaboration tool',
    conceptboardLinkAttachmentModalBoxTitle: 'Create new Conceptboard project attachment',
    conceptboardLinkAttachmentModalBoxSubText: 'Please enter (or paste) a link to a Conceptboard project',
    conceptboardLinkAttachmentCreateNewText: 'Create New Conceptboard Link Attachment',
    conceptboardLinkAttachmentAddExistingText: 'Add existing Conceptboard Link Attachment',
    conceptboardSaveButtonCreate: 'Create',
    conceptboardSaveButtonSaveToList: 'Save to List',
    etherpadTypeTitle: 'Etherpad',
    excalidrawTypeTitle: 'Excalidraw',
    youtubeLinkTypeTitle: 'YouTube',
    youtubeLinkTypeDescription: 'Watch a video together',
    tldrawTypeTitle: 'Tldraw',
    linkTypeDescription: 'Add link to a website, tool or file',
    etherpadTypeDescription: 'Real-time document editing tool',
    tldrawTypeDescription: 'Real-time whiteboard tool',
    enterUrlActionTitle: 'Please enter an Internet-Link (including https://)',
    deleteAttachmentConfirmationTitle: 'Are you sure you want to delete the link to this file?',
    editAttachmentTitle: 'Edit file description',
    noDescriptionProvidedWarning: 'No description provided',
    createdAtTitle: 'Created',
    justNowTitle: 'just now',
    oneMinutePassedTitle: '1 minute ago',
    minutesPassedTitle: '{quantity} minutes ago',
    oneHourPassedTitle: '1 hour ago',
    hoursPassedTitle: '{quantity} hours ago',
    yesterdayTitle: 'yesterday',
    daysPassedTitle: '{quantity} days ago',
    weeksPassedTitle: '{quantity} weeks ago',
    monthsPassedTitle: '{quantity} months ago',
    aYearPassedTitle: 'a year ago',
    yearsPassedTitle: '{quantity} years ago',
    giveAttachmentNameTitle: 'Give your file a title',
    giveAttachmentDescriptionTitle: 'Add a description to your file',
    linkAttachmentModalBoxTitle: 'Create new link attachment',
    linkAttachmentModalBoxSubText: 'Please enter (or paste) a link to a webpage that can be opened in a new browser tab',
    youtubeLinkAttachmentModalBoxTitle: 'Create a new YouTube video attachment',
    youtubeLinkAttachmentModalBoxSubText: 'Paste below the link to any YouTube video',
    youtubeLinkAttachmentModalVideoPinText: 'Pin video to the room',
    youtubeLinkAttachmentModalVideoPinUpperText:
        'The video can be pinned to the room, so that it is prominently displayed at the top of the attachments panel.',
    youtubeVideoPlaying: 'Video playback',
    youtubePlaybackControl: 'Controlled by',
    youtubePlaybackTransfer: 'Transfer video control playback to',
    youtubePinnedVideo: 'Pinned video',

    // Speaker stats
    speakerStatsTitle: 'Virtual Moderator',
    totalTalkTimeTitle: 'Total talk time',
    personalTalkTimeToggle: 'Show me my personal talk time.',
    // eslint-disable-next-line quotes
    talkingTooMuchToggle: "Tell me when I'm talking too much.",
    experimentalLabelTitle: 'Experimental',
    noDataTitle: 'No data yet',
    talkingMoreDescription: 'FYI - You are talking more than everyone else.',
    talkingMoreDescription2: 'Would it now be time to give the floor to someone else?',
    startButtonLabel: 'Start',
    roundTableTitle: 'Round table',
    applyTimer: 'Apply timer',
    startRoundTableModeTitle: 'Start round table mode',
    stopRoundTableModeTitle: 'Stop round table mode',
    roundTableModeDialogBoxTitle: 'Round Table Mode',
    youAreOnTitle: 'You are on!',
    youAreTheLastSpeakerTitle: 'You are the last speaker',
    clickNextWhenYouAreDoneTitle: 'Click "next" when you are done',
    nextActionTitle: 'Next',
    nextActionTitle2: 'Next',
    isOnTitle: 'is on!',
    minutesLabel: 'Minutes',
    addUserToRoundTableButtonLabel: 'Include',
    removeUserFromRoundTableButtonLabel: 'Remove',

    // General Time Words
    from: 'From',
    at: 'at',
    to: 'to',
    until: 'until',
    since: 'since',
    everyWeekOn: 'Every week on',
    everyday: 'Everyday',
    weekly: 'weekly',
    daily: 'daily',
    noRepeat: 'no repeat',

    // Months
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    // MonthsInShortForm
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may2: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',

    // Weekdays
    monday: 'Mondays',
    tuesday: 'Tuesdays',
    wednesday: 'Wednesdays',
    thursday: 'Thursdays',
    friday: 'Fridays',
    saturday: 'Saturdays',
    sunday: 'Sundays',

    // ImagePicker
    uploadNewImageTitle: 'Upload a new image',
    uploadNewImageActionTitle: 'Upload new image',
    recentlyUploadedImages: 'Recently uploaded images',
    uploadActionTitle: 'Upload',
    clickToUploadImage: 'Click to upload image',
    deleteImageDescription: 'Are you sure you want to delete this image?',
    imageTitle: 'Image',
    uploadCap: 'The size of the image must not exceed 2 megabytes',
    uploadCapError: 'The size of the image you are trying to upload is larger than 2 megabytes',
    onImagePickerModalClose: 'Confirm and close',

    // OverlaySelector
    videoOverlayLabel: 'Video overlay',
    overlayLabel: 'Overlay',
    backgroundLabel: 'Background',
    checkboxLabel: 'Use transparency of image',

    // RegistrationForm
    registrationFormLabel: 'Entrance to the CAMPUS',
    registrationFormPlaceholder: 'Please enter a name',
    registrationFormErrorMessage: 'Please enter a valid name',
    registrationFormInfoMessage: 'Please enter your name, nickname or a psydonym. This information is not saved in our system and is deleted after you leave.',

    // User Profile
    editNamePlaceholder: 'Type in your name',
    editNameErrorMessage: 'The minimum limit is 1 character',
    updateImageButtonLabel: 'Update image',
    editNameButtonLabel: 'Edit name',

    // OnboardingVideo
    onboardingVideoTitle: 'This short tour explains the most important features. ',

    // FlagsView
    goBackActionTitle: 'Go back',
    darkModeActionTitle: 'Use dark mode',
    enableThisFrag1: 'If you enable this flag, you will be able to use CAMPUS in dark mode',
    useJitsiEnv: 'Use the Jitsi staging environment',
    enableThisFrag2: 'If you enable this flag, you will not be able to talk to users who have not enabled this flag.',
    useTestActivityTimersTitle: 'Use test activity timers',
    useTestActivityTimersDescription:
        'Shortens all inactivity, away, lobby, and midnight timers for quick testing. The page reloads when you toggle this. Disable when done.',
    useMatrixChatTitle: 'Enable Matrix chat',
    useMatrixChatDescription:
        'Matrix chat is still under development and is switched off outside the beta environment. Turning it on connects to the chat server and shows the chat widget on your personal dashboard. The page reloads when you toggle this.',

    // App Errors
    logInTwiceTitle: 'You logged into the same area twice',
    logInTwiceDescription:
        'You were automatically disconnected in this tab, because you logged into the same area from somewhere else. You can only log into the same area with the same account from one tab.',
    sessionExpiredTitle: 'Your session expired.Your have been automatically logged out.',
    sessionExpiredDescription: 'Your have been automatically logged out',
    sessionExpiredReasonTitle: 'Here are reasons why this might happen:',
    sessionExpiredReason1: 'Your magic link was valid a longer time already and now expired due to security reason. A new login is required.',
    sessionExpiredReason2: 'You tried to use a bookmark to enter a personal room. This is not allowed due to security reason.',
    sessionExpiredReason3: 'You might have entered the Campus from another device.',
    sessionExpiredReconnect: 'Reconnect',
    resourceNotFoundTitle: 'The resource you have requested could not be found',
    resourceNotFoundDescription: 'You have been automatically logged out',
    unexpectedErrorOccuredTitle: 'An unexpected error has occured',
    unexpectedErrorOccuredDescription:
        'You were automatically disconnected because an unexpected error occured. Please contact your account manager or info@ivicos.eu',

    // loadingStrings
    loadingStringAreas: 'Loading areas...',
    loadingStringSettings: 'Loading settings...',
    loadingStringMembersList: 'Loading members list',
    loadingStringInvitation: 'Loading invitation...',
    loadingStringWaitingAreas: 'Entering waiting area',
    loadingStringBilling: 'Loading billing area...',
    loadingStringFindCampusFetchingOrgs: 'Entering CAMPUS...',
    loadingStringCoreInitializing: 'Loading... Please wait...',
    loadingStringCoreRoom: 'Entering into the room...',
    loadingStringCoreArea: 'Looking for available rooms...',
    loadingStringCoreDashboardLobby: 'Stepping-in the CAMPUS Lobby...',
    loadingStringCoreDashboardMembers: 'Loading member list',
    loadingStringCoreDashboardSettings: 'Switching to CAMPUS settings',
    loadingStringCoreDashboardBilling: 'Checking data...',
    loadingStringCoreDashboardChangelog: 'Updating list',
    loadingStringSubAreas: 'Move around the CAMPUS',
    loadingStringVisitorExit: 'Your visit is ending—please wait...',
    loadingStringHostPerspectiveWaitingArea: 'Stepping-in the CAMPUS visitor reception...',

    // SetupAssistant
    setProfileImage: 'Set profile image',
    setOrgLogo: 'Set logo of your organisation',
    setOrgColor: 'Set color of your organisation',
    SetupAssistantLabelOpenPrimary: 'Complete your company profile!',
    SetupAssistantLabelOpenSecondary: 'There are still a few things that need to be done as a CAMPUS-manager before your CAMPUS is complete!',
    SetupAssistantLabelCompletedPrimary: 'Setup completed!',
    SetupAssistantLabelCompletedSecondary: 'You have completed your company profile set up!',
    completeLabel: 'complete',
    completedLabel: 'completed',
    openLabel: 'open',

    // OnboardingVideo
    introVideoTitle: 'Short onboarding video',
    tutorialConfirmationTitle: 'And now quick tips to familiarise yourself in your new office!',

    // Intro Steps
    areaIntroStep1: 'Welcome to this guided tutorial to your CAMPUS! Simply click next to start exploring. ',
    areaIntroStep2:
        'Here you can find the Areas tab and the Change Log tab. For CAMPUS managers, along with these you will find the Manage Access and CAMPUS Settings tabs.',
    areaIntroStep3: 'This is an area. Within areas you can create rooms. There can be several areas on the CAMPUS.',
    campusSettingIntroStep1: 'Here you can store your profile picture and choose individual settings',
    campusSettingIntroStep2: 'Here you can set your CAMPUS name, brand color and logo.',
    memberIntroStep1:
        'Invite members to your CAMPUS by typing in their email and clicking the invite button. You can cancel or resend invitations in the table below, as well as remove members who have already joined.',
    memberIntroStep2:
        'This table will show all users you have invited to your CAMPUS, whether they have accepted the invitation or not. Their name and profile picture will be displayed once they accept the invitation.',
    memberIntroStep3: 'Filter the table by email.',
    roomIntroStep1: 'This section contains all the information regarding your account at CAMPUS and lets you choose and set a personal profile image.',
    roomIntroStep2: 'Every member has their own personal room when they enter an area. Hover over their names to reveal the communication options.',
    roomIntroStep3:
        'Rooms are customisable and are perfect for meetings, workshops, or a space to chat. They have more features than your personal room, and can be deleted or archived as you please.',
    roomIntroStep4: 'Here you can invite visitors who are not part of your CAMPUS.',
    roomIntroStep5: 'Use these icons to adjust the video and call settings.',
    roomIntroStep6: 'These icons allow you to access CAMPUS video features, like speaker stats.',
    roomIntroStep7: 'You successfully completed the tutorial. Enjoy your stay on CAMPUS!',

    // Not Supported Browser warning
    notSupportedBrowserString1: 'is a browser application that does not require any software to be installed.',
    notSupportedBrowserString2: 'As /devices/ and /devices/ are frequently updated and sometimes cause incompatibilities, not all versions can be supported.',
    notSupportedBrowserString3: 'Please note that ivCAMPUS cannot be used with the /browser/ and /browser/ versions of /browser/ and /browser/.',
    notSupportedBrowserString4: 'We recommend using one of the following browsers:',
    notSupportedBrowserFooterText: 'For more information of ivCAMPUS please /visit our website /or contact us /here',
    downloadHere: 'Download here',

    // Setup complete page
    setupCompletePageTitle: 'Setup complete!',

    // Profile page
    profilePageTitle: 'Setup Your Profile',
    profilePageTextFieldPlaceholder: 'Type in your name and surname',

    // ivCAMPUS Setup page
    ivCAMPUSSetupPageTitle: 'CAMPUS Setup',
    nameLabel: 'Name',
    organisationNamePlaceholder: 'Company name',
    sizeOfTheOrganisationLabel: 'Size',
    sizeOfTheOrganisationPlaceholder: 'How many people are in your organisation?',
    locationsLabel: 'Locations',
    howManyLocationsPlaceholder: 'How many locations do you have?',
    ivCAMPUSSetupPageCheckBoxDescription1: 'I hereby confirm that I am setting up a CAMPUS instance for the purposes of',
    ivCAMPUSSetupPageCheckBoxDescription3: '',
    ivCAMPUSSetupPageCheckBoxDescription2: 'I hereby confirm that I am setting up a CAMPUS instance for the purposes of (company name).',
    moreThan500: 'more than 500',
    moreThan20: 'more than 20',
    enterOrgNameErrorMessage: 'Please enter a valid Organisation name',
    enterOrgSizeErrorMessage: 'Please select the size of the organisation',
    enterOrgLocationErrorMessage: 'Please select the amount of locations',

    // FindCampus page
    findCampusPageTitle: 'Log into organisation...',
    findCampusPageLabel: 'Jump to:',
    findCampusPagePlaceholder: 'Select CAMPUS',
    findCampusHintTitle: 'Useful hint...',
    findCampusHintDescription1: 'For the next few days, just go to ivCAMPUS in your usual browser: ',
    findCampusHintLink: 'https://ivicos-campus.app',

    findCampusHintDescription2: 'After 7 days, you\'ll simply send yourself a new magic link.',
    hideOption: 'Hide options',
    showOption: 'Show me other options',
    startSetupButtonTitle: 'Create a new CAMPUS...',
    startSetupButtonDescription: 'Create new organization',
    seeAllInvitations: 'See all invitations',
    invitationTitle: 'You have been invited to join',
    noSponsorModalTitle: 'Access inactive',
    noSponsorModalWelcome: 'Welcome to ivCAMPUS.',
    noSponsorModalDescription: 'You now have the opportunity to experience the full capabilities of Campus. ',
    noSponsorModalTip: 'After registering, you can view the remaining time of your trial period in the "Billing" tab.',
    trialPeriodOverButConsider1: 'Your trial period is over.',
    trialPeriodOverButConsider2: 'However you can continue if you…',
    createNewBuildingDescriptions: {
        description1: 'Please be aware of the implications of this action. You will be creating a new location.',
        description2: 'You will need to invite members to this building and manage this new building and rooms.',
        description3: 'This is useful, for example, to make it easier for different organizations to work together.'
    },

    // General Button Text
    enter: 'Enter',
    login: 'Log In',
    accept: 'Accept',
    decline: 'Decline',
    acceptAndJoin: 'Accept & Join',
    loading: 'Loading...',
    somethingWentWrong: 'Something went wrong :(',
    continue: 'Continue',
    finish: 'Finish',
    okAction: 'Ok',

    // General Text
    here: 'here',
    orVisitOur: 'or visit our',
    helpPage: 'help page',
    empty: 'Empty',
    signedInAs: 'Signed in as ',
    errorHasOccured: 'Error has occured',
    talkingToMicrosoft: 'Talking to the Microsoft Identity Platform...',
    settingUpYourCampus: 'Setting up your CAMPUS...',

    // Error messages
    min3: 'name should be minimum 3 character',
    max7: 'name should be maximum 72 character',
    minimumLimit: 'The minimum limit is 3 characters',

    // Login Page
    signInTitle: 'Access',
    emailPlaceHolder: 'Type in your work email address',
    emailButtonText: 'Receive magic link',
    emailErrorMessage: 'Please enter a valid email address!',
    loginPageDescription3: 'We will send an access-link to your email-address.',
    orOptionTitle: 'or',
    developedByTitle1: 'Developed by',
    developedByTitle2: '(c) ivicos GmbH, Germany',
    newToPassWordlessAcesss: 'New to passwordless access?',
    clickHereToKnowMore: 'Click here to know more.',
    newSince: 'New, since 03/2025',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart1: 'To receive the magic link',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart2: ' please enter the code below',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart3: 'Enter code',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart4: 'Verify',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart5: 'Please verify that the code is correct and capitalization is respected.',

    // NewUserAwaitingConfirmation Page
    userConfirmationPageTitle: 'You will receive a magic link by email to grant you access to CAMPUS.',
    userConfirmationPageDescription1: 'Check your email inbox (and your spam folder).',
    userConfirmationPageDescription3: 'Click on the button or copy the access link and paste it into this or any tab.',
    userConfirmationPageDescription4: 'Didn\'t receive an email within a few minutes?',
    userConfirmationPageDescription5: 'Please re-enter your email address',
    userConfirmationPageDescription6: 'so that another system can send the magic link again.',

    // MagicLinkVerification
    processingLoadingText: 'Processing...',

    // NewUserAccessGranted
    accessGrantedTitle: 'Access granted!',
    accessGrantedDescription1: ' was confirmed.',
    accessGrantedDescription2: 'Please click',
    accessGrantedDescription3: 'if you are not automatically being redirected to CAMPUS.',

    // UserAccessGranted
    userAccessGrantedDescription1: 'Hello ',
    userAccessGrantedDescription2: '! Your access has been confirmed.',
    userAccessGrantedDescription3: 'if you are not automatically being directed to CAMPUS.',

    // NewUserSomethingWrong
    somethingWrongTitle: 'Something went wrong!',
    newUserSomethingWrongDescription1: 'An error occurred during the authentication process.',
    newUserSomethingWrongDescription2: 'To receive a new access link, please click',
    newUserSomethingWrongDescription3: 'If the error still occurs, contact us',

    // AccountCreationSuccessful
    accountCreationSuccessfulTitle1: 'An account for ',
    accountCreationSuccessfulTitle2: ' has been successfully created!',
    accountCreationSuccessfulDescription: 'Please check your e-mail inbox (also your spam folder) and click on the access link to complete your profile.',

    // AccountCreationSomethingWentWrong
    accountCreationSomethingWentWrongDescription1: 'The creation of a new account could not be completed.',
    accountCreationSomethingWentWrongDescription2: 'Please contact us',

    // LoadingStrings
    creatingAnAccountLoadingString: 'Creating an account...',
    creatingAccountAwaitingServerLoadingString: 'Waiting for confirmation...',

    // PasswordlessAccessModal;
    passwordLessAccessModalTitle: 'What is passwordless access?',
    passwordLessAccessModalDescription1:
        'Passwordless authentication is a method of verifying a user’s identity without using passwords. This method provides immediate protection against the most dangerous and common cyberattacks.',
    passwordLessAccessModalDescription2:
        'Users are this way also protected from scam emails and text messages that attempt to steal their passwords, since there’s no password to be stolen.',
    passwordLessAccessModalDescription3: 'How does it work?',
    passwordLessAccessModalDescription4:
        'The method is simple. Instead of being asked for a password, users only need to enter their email address in the login box. They will receive an email with a link they click to access. For security reasons, such link is sent to users each time they attempt to log in.',
    passwordLessAccessModalDescription5:
        'In the past, people went to work and showed their employee ID to the gatekeeper. Today it works with a simple link to be continuously present on CAMPUS.',

    integrationsTitle: 'Integration',

    // OUTLOOK WIDGET
    outlookWidgetConnectTitle: 'Mails',
    outlookWidgetConnectDescription: 'Connect your Outlook account to see your inbox here.',
    outlookWidgetConnectButton: 'Connect Outlook',
    outlookWidgetDisconnectLink: 'Disconnect',
    outlookWidgetInboxTitle: 'Inbox',
    outlookWidgetComposeButton: 'New Email',
    outlookWidgetEmptyInbox: 'No messages in your inbox.',
    outlookWidgetErrorMessage: 'Something went wrong.',
    outlookWidgetRetryButton: 'Retry',
    outlookWidgetReplyButton: 'Reply',
    outlookWidgetReplyAllButton: 'Reply All',
    outlookWidgetDeleteButton: 'Delete',
    outlookWidgetSendButton: 'Send',
    outlookWidgetCancelButton: 'Cancel',
    outlookWidgetToLabel: 'To',
    outlookWidgetSubjectLabel: 'Subject',
    outlookWidgetBodyLabel: 'Message',
    outlookWidgetSendFailed: 'Failed to send. Please try again.',
    outlookWidgetDeleteFailed: 'Failed to delete. Please try again.',
    outlookWidgetAccountSettingsTitle: 'Account',
    outlookWidgetAccountSectionTitle: 'Connected account',
    outlookWidgetBackButton: 'Back',
    outlookWidgetAttachButton: 'Attach file',
    outlookWidgetAttachSizeError: 'One or more files exceed 3 MB. Please use Outlook to send large attachments.',
    outlookWidgetAttachSizeHint: 'Attachments over 3 MB can only be sent directly from Microsoft Outlook.',
    outlookWidgetOpenInOutlook: 'Open in Microsoft Outlook',
    // ZAMMAD WIDGET
    zammadWidgetTitle: 'Zammad Tickets',
    zammadWidgetCategoryLabel: 'Category',
    zammadWidgetColumnPickerTitle: 'Columns',
    zammadWidgetNoColumnsSelected: 'No columns selected',
    zammadWidgetEmptyState: 'No tickets in this category.',
    zammadWidgetErrorMessage: 'Something went wrong.',
    zammadWidgetUnreachableTitle: 'Can\'t reach your Zammad server',
    zammadWidgetUnreachableDescription: 'Check that you\'re connected to your organisation\'s network or VPN. The Zammad server may also not be responding.',
    zammadWidgetBaseUrlError: 'This organisation\'s Zammad address doesn\'t look right. Please check it in Campus settings.',
    zammadWidgetRetryButton: 'Retry',
    zammadWidgetConnectTitle: 'Connect your Zammad account',
    zammadWidgetConnectDescription: 'Connect your Zammad account to see your tickets here.',
    zammadWidgetDisconnectedHeading: 'No provider connected yet',
    zammadWidgetConnectBackDescription: 'Connect your Zammad account to see your tickets here.',
    zammadWidgetConnectBaseUrlLabel: 'Base URL',
    zammadWidgetConnectTokenLabel: 'Your API token',
    zammadWidgetConnectButton: 'Connect',
    zammadWidgetDisconnectButton: 'Disconnect Zammad account',
    zammadWidgetDisconnectConfirmTitle: 'Disconnect Zammad?',
    zammadWidgetDisconnectConfirmWarning: 'You\'ll stop seeing your tickets here until you connect again.',
    zammadWidgetHelpResourcesLabel: 'Help & resources',
    zammadWidgetGenerateTokenLabel: 'Generate a token',
    zammadWidgetGenerateTokenText: 'Create an API token in your Zammad account',
    zammadWidgetGuideLinkLabel: 'Guideline',
    zammadWidgetGuideLinkText: 'Help to create a Zammad API token',
    zammadAttributeNumber: '#',
    zammadAttributeTitle: 'Title',
    zammadAttributeCustomer: 'Customer',
    zammadAttributeOrganization: 'Organisation',
    zammadAttributeGroup: 'Group',
    zammadAttributeOwner: 'Owner',
    zammadAttributeState: 'State',
    zammadAttributePendingTime: 'Pending till',
    zammadAttributePriority: 'Priority',
    zammadAttributeArticleCount: 'Article#',
    zammadAttributeTimeUnit: 'Accounted Time',
    zammadAttributeEscalationAt: 'Escalation at',
    zammadAttributeFirstResponseEscalationAt: 'Escalation at (First Response Time)',
    zammadAttributeUpdateEscalationAt: 'Escalation at (Update Time)',
    zammadAttributeCloseEscalationAt: 'Escalation at (Close Time)',
    zammadAttributeLastContactAt: 'Last contact',
    zammadAttributeLastContactAgentAt: 'Last contact (agent)',
    zammadAttributeLastContactCustomerAt: 'Last contact (customer)',
    zammadAttributeFirstResponseAt: 'First response',
    zammadAttributeCloseAt: 'Closing time',
    zammadAttributeLastCloseAt: 'Last closing time',
    zammadAttributeCreatedBy: 'Created by',
    zammadAttributeCreatedAt: 'Created at',
    zammadAttributeUpdatedBy: 'Updated by',
    zammadAttributeUpdatedAt: 'Updated at',
    zammadCategoryMyAssigned: 'My assigned Tickets',
    zammadCategoryAllUnassigned: 'Unassigned & Open Tickets',
    zammadCategoryMyPendingReached: 'My "Pending reached" Tickets',
    zammadCategoryMySubscribed: 'My subscribed Tickets',
    zammadCategoryAllOpen: 'Open Tickets',
    zammadCategoryAllPendingReached: '"Pending reached" Tickets',
    zammadCategoryAllEscalated: 'Escalated Tickets',
    zammadCategoryMyTickets: 'My Tickets',
    zammadCategoryMyOrganization: 'My Organization Tickets',
    zammadStateNew: 'New',
    zammadStateOpen: 'Open',
    zammadStatePendingReminder: 'Pending reminder',
    zammadStatePendingClose: 'Pending close',
    zammadStateClosed: 'Closed',
    zammadPriorityLow: 'Low',
    zammadPriorityNormal: 'Normal',
    zammadPriorityHigh: 'High',
    // OPENPROJECT WIDGET
    openProjectWidgetTitle: 'OpenProject',
    openProjectWidgetViewLabel: 'Show',
    openProjectWidgetViewAssigned: 'Assigned to me',
    openProjectWidgetViewWatched: 'Watched by me',
    openProjectWidgetViewCreated: 'Created by me',
    openProjectWidgetEmptyState: 'No open work packages here.',
    openProjectWidgetErrorMessage: 'Could not load your work packages.',
    openProjectWidgetUnreachableMessage: 'OpenProject cannot be reached right now.',
    openProjectWidgetTokenInvalidMessage: 'OpenProject no longer accepts your API token. Please connect again.',
    openProjectWidgetRetryButton: 'Retry',
    openProjectWidgetReconnectButton: 'Connect again',
    openProjectWidgetLoadMoreButton: 'Show more',
    openProjectWidgetOverdueLabel: 'Overdue',
    openProjectWidgetDisconnectedHeading: 'Link widget to OpenProject',
    openProjectWidgetConnectDescription: 'Connect your OpenProject account to see your work packages here.',
    openProjectWidgetConnectTitle: 'Connect your OpenProject account',
    openProjectWidgetConnectBackDescription: 'Create an API token in OpenProject and paste it here.',
    openProjectWidgetConnectBaseUrlLabel: 'OpenProject URL',
    openProjectWidgetConnectTokenLabel: 'Your API token',
    openProjectWidgetConnectButton: 'Connect',
    openProjectWidgetConnectTokenInvalidError: 'OpenProject did not accept this API token.',
    openProjectWidgetHelpResourcesLabel: 'Help & resources',
    openProjectWidgetGenerateTokenLabel: 'Create an API token',
    openProjectWidgetGenerateTokenText: 'Account settings → Access tokens in OpenProject',
    openProjectWidgetSettingsTitle: 'Settings',
    openProjectWidgetDisconnectButton: 'Disconnect OpenProject account',
    openProjectWidgetDisconnectConfirmTitle: 'Disconnect OpenProject?',
    openProjectWidgetDisconnectConfirmWarning: 'You\'ll stop seeing your work packages here until you connect again.',
    // MATRIX CHAT WIDGET
    matrixChatWidgetTitle: 'E2EE Chat',
    matrixChatWidgetUnavailable: 'Secure E2EE-Chat is currently unavailable – please send fluid messages or talk to colleagues directly.',
    matrixChatWidgetConnecting: 'Connecting to secure chat…',
    matrixChatWidgetReconnecting: 'Reconnecting to secure chat…',
    matrixChatWidgetDisconnected: 'Secure chat is disconnected.',
    matrixChatWidgetReconnectButton: 'Reconnect',
    matrixChatWidgetPersonalSection: 'Personal',
    matrixChatWidgetGroupsSection: 'Groups',
    matrixChatWidgetSearchPlaceholder: 'Search names / groups',
    matrixChatWidgetEmptyList: 'No conversations yet.',
    matrixChatWidgetNewChatHoverText: 'New chat',
    matrixChatWidgetNewGroupHoverText: 'New group',
    matrixChatWidgetCreateChatTitle: 'Start a new chat',
    matrixChatWidgetCreateGroupChatTitle: 'Start a new group chat',
    matrixChatWidgetCreateChatConfirm: 'Start chat',
    matrixChatWidgetCreateChatCancel: 'Cancel',
    matrixChatWidgetGroupChatMinMembersHint: 'Select at least 2 people to start a group chat',
    matrixChatWidgetComposerPlaceholder: 'Message…',
    matrixChatWidgetEncryptedLabel: 'End-to-end encrypted',
    matrixChatWidgetSendWithEnterLabel: 'Send message with Enter',
    matrixChatWidgetSendWithEnterOnHint: 'On: pressing Enter sends your message.',
    matrixChatWidgetSendWithEnterOffHint: 'Off: press Ctrl/Cmd + Enter to send your message.',
    matrixChatWidgetFontSizeLabel: 'Message text size',
    matrixChatWidgetSettingsTitle: 'Settings',
    matrixChatWidgetExternalClientLabel: 'Use another chat app',
    matrixChatWidgetExternalClientHint: 'Use these details to sign in from Thunderbird or another Matrix-compatible chat app.',
    matrixChatWidgetExternalClientButton: 'Show sign-in details',
    matrixChatWidgetExternalClientHideButton: 'Hide sign-in details',
    matrixChatWidgetExternalClientPasswordWarning:
        'Don\'t change your password from Thunderbird or another app — that would sign you out of web chat here and stop this password from working.',
    matrixChatWidgetExternalClientMatrixIdLabel: 'Matrix ID',
    matrixChatWidgetExternalClientHomeserverLabel: 'Homeserver',
    matrixChatWidgetExternalClientPasswordLabel: 'Password',
    matrixChatWidgetExternalClientRecoveryKeyLabel: 'Recovery key',
    matrixChatWidgetExternalClientRecoveryKeyHint: 'If the app asks you to verify this device or enter a security/recovery key, paste this value.',
    matrixChatWidgetExternalClientCopyButton: 'Copy',
    matrixChatWidgetExternalClientError: 'Could not load your sign-in details. Please try again.',
    matrixChatWidgetHelpResourcesLabel: 'Help & resources',
    matrixChatWidgetInviteLinkLabel: 'Send an invite link',
    matrixChatWidgetInviteLinkHint: 'Share this link so others can find and message you from any Matrix-compatible chat app.',
    matrixChatWidgetInviteLinkCopyButton: 'Copy invite link',
    matrixChatWidgetGuideLinkLabel: 'Guideline',
    matrixChatWidgetGuideLinkText: 'How to chat, sign in, and connect other apps',
    matrixChatWidgetSettingsBackButton: 'Back',
    matrixChatWidgetStartChatPrompt: 'Start a chat with {0}?',
    matrixChatWidgetStartGroupChatPrompt: 'Start a group chat with {0}?',
    matrixChatWidgetPresencePromptDismiss: 'Not now',
    matrixChatWidgetLeaveChatTooltip: 'Leave this chat',
    matrixChatWidgetLeaveChatTitle: 'Leave this chat?',
    matrixChatWidgetLeaveChatBody: 'This removes the chat from your list only and you will stop receiving its messages. Other participants keep the chat.',
    matrixChatWidgetLeaveChatConfirm: 'Leave',
    matrixChatWidgetLeaveChatCancel: 'Cancel',
    matrixChatWidgetAttachTooltip: 'Attach a file',
    matrixChatWidgetDownloadTooltip: 'Download',
    matrixChatWidgetUploadError: 'The file could not be sent. Please try again.',
    matrixChatWidgetFileTooLargeError: 'The file is too large. The maximum size is 50 MB.',
    matrixChatWidgetPreviewUnavailable: 'Preview is not available for this file type. Download it to open.',
    matrixChatWidgetAddReactionTooltip: 'Add reaction',
    calendarWidgetTitle: 'Calendar',
    calendarWidgetConnectDescription: 'Connect your Microsoft account to see today\'s events.',
    calendarWidgetConnectButton: 'Connect Calendar',
    calendarWidgetSharedLoginTooltip: 'Signing in will connect Email, Calendar, and Tasks at once.',
    calendarWidgetEmptyDay: 'No events today.',
    calendarWidgetErrorMessage: 'Something went wrong.',
    calendarWidgetRetryButton: 'Retry',
    calendarWidgetNewEventButton: 'New Event today',
    calendarWidgetDeleteButton: 'Delete',
    calendarWidgetDeleteConfirm: 'Delete this event?',
    calendarWidgetCancelButton: 'Cancel',
    calendarWidgetSaveButton: 'Save',
    calendarWidgetTitleLabel: 'Title',
    calendarWidgetStartLabel: 'Start',
    calendarWidgetEndLabel: 'End',
    calendarWidgetLocationLabel: 'Location',
    calendarWidgetDescriptionLabel: 'Description',
    calendarWidgetDeleteFailed: 'Failed to delete event. Please try again.',
    calendarWidgetSaveFailed: 'Failed to save event. Please try again.',
    calendarWidgetJoinButton: 'Join',
    calendarWidgetAttendeesLabel: 'Attendees',
    calendarWidgetAccountSettingsTitle: 'Account',
    calendarWidgetDisconnectButton: 'Disconnect',
    calendarWidgetBackButton: 'Back',
    calendarWidgetEditButton: 'Edit',
    calendarWidgetEditEventTitle: 'Edit Event',
    calendarWidgetEditFailed: 'Failed to update event. Please try again.',
    calendarWidgetDateLabel: 'Date',
    calendarWidgetAttendeePlaceholder: 'Email address',
    todosWidgetTitle: 'Tasks',
    todosWidgetConnectDescription: 'Connect your Microsoft account to see your tasks.',
    todosWidgetConnectButton: 'Connect Tasks',
    todosWidgetSharedLoginTooltip: 'Signing in will connect Email, Calendar, and Tasks at once.',
    todosWidgetEmptyList: 'No open tasks.',
    todosWidgetErrorMessage: 'Something went wrong.',
    todosWidgetRetryButton: 'Retry',
    todosWidgetInputPlaceholder: 'Add a task...',
    todosWidgetTitleLabel: 'Title',
    todosWidgetDeleteFailed: 'Failed to delete task. Please try again.',
    todosWidgetCompleteFailed: 'Failed to complete task. Please try again.',
    todosWidgetCreateFailed: 'Failed to create task. Please try again.',
    todosWidgetDueToday: 'Due today',
    todosWidgetDueTomorrow: 'Due tomorrow',
    todosWidgetDuePrefix: 'Due',
    todosWidgetOverdue: 'Overdue',
    todosWidgetToday: 'Today',
    todosWidgetTomorrow: 'Tomorrow',
    todosWidgetOverdueDaysSuffix: 'd.',
    todosWidgetUpcoming: 'Upcoming',
    todosWidgetAddButton: 'Add',
    todosWidgetNewTaskTitle: 'New Task',
    todosWidgetCancelButton: 'Cancel',
    todosWidgetAccountSettingsTitle: 'Account',
    todosWidgetBackButton: 'Back',
    todosWidgetEditFailed: 'Failed to update task. Please try again.',
    todosWidgetDueDateLabel: 'Due date',
    todosWidgetReminderLabel: 'Reminder',
    todosWidgetRecurrenceLabel: 'Repeat',
    todosWidgetRecurrenceNone: 'None',
    todosWidgetRecurrenceDaily: 'Daily',
    todosWidgetRecurrenceWeekly: 'Weekly',
    todosWidgetRecurrenceMonthly: 'Monthly',
    todosWidgetRecurrenceYearly: 'Yearly',
    todosWidgetRecurrenceEditHint: 'Repeat can only be changed in Microsoft To Do.',
    todosWidgetOpenInMicrosoftTodo: 'Open in Microsoft To Do',
    providerConnectionPanelTitle: 'Providers',
    providerConnectionPanelNoProviderHeading: 'No provider connected yet',
    providerConnectionPanelNoProviderSubtext: 'Connect your provider to get started',
    providerConnectionPanelConnectedTab: 'Connected',
    providerConnectionPanelOtherTab: 'Other Providers',
    providerConnectionPanelComingSoon: 'Coming soon',
    providerConnectionPanelDisconnect: 'Disconnect',
    providerConnectionPanelBackButton: 'Back',
    widgetFilterLabel: 'Filter',
    widgetFilterLegendLabel: 'Filter / Legend',
    calendarWidgetFilterLegend: 'Shows today\'s calendar events only.',
    emailWidgetFilterLegend: 'Shows today\'s emails and unread emails from yesterday.',
    todosWidgetFilterLegend: 'Shows overdue, today\'s, and tasks of the current week — up to and including Sunday of this week.',
    widgetSettingsHoverText: 'Settings / Filter',
    widgetOpenInAppHoverText: 'Open in app',
    widgetRefreshHoverText: 'Refresh',
    providerMicrosoftName: 'Microsoft',
    providerGoogleName: 'Google',
    providerOtherName: 'Other Providers',
    outlookWidgetDisconnectedSubtext: 'Connect a provider to access your mails.',
    calendarWidgetDisconnectedSubtext: 'Connect a provider to access your calendar.',
    todosWidgetDisconnectedSubtext: 'Connect a provider to access your tasks.',
    microsoftProviderTitle: 'Microsoft',
    microsoftProviderDescription: 'Enable the display of widgets on the desk (Microsoft Mail, Calendar, Tasks) for all CAMPUS members.',
    googleProviderTitle: 'Google',
    googleProviderDescription: 'Enable Google integrations (Gmail, Calendar, Tasks) for your campus members.',
    providerEnabledLabel: 'Enabled',
    providerDisabledLabel: 'Disabled',

    // CAMPUS SETTINGS - organization
    organizationTitle: 'Organization',

    // WebBrowserNotification
    notificationTitle: 'Manage Notification Settings',
    notificationRequestMessage: 'Click the button below to enable browser\'s notifications:',
    notificationRequestButton: 'Enable Notifications',
    notificationEnabledText: 'Notifications Enabled!',
    notificationCopyInstruction: 'Copy the link below and paste it into a new tab to manage your browser\'s notification settings:',
    notificationCopyButton: 'Copy Link',
    notificationCopiedText: 'Copied',
    notificationGuideText: 'View the detailed guide on managing system and browser notifications:',
    notificationGuideLinkText: 'Click to view the guide in a new tab',
    notificationCloseButton: 'Close',
    notificationMessageTitle: 'You seem to be absent on your CAMPUS!',
    notificationMessageBody: 'Make yourself visible to your colleagues: Click here',

    // WebRTCDiagnostics
    sectionBasic: 'Basic Information',
    sectionCallNetwork: 'Call Issues and Network Information',
    sectionAdditional: 'Additional Information',
    sectionFirewall: 'Firewall Settings',
    webRTCDiagnosticsChecklistTitle: 'ivCAMPUS Video Call Troubleshooting Checklist',
    webRTCDiagnosticsTitle: 'WebRTC Diagnostics',
    webRTCDiagnosticsBrowserLabel: 'Which web browser are you using?',
    webRTCDiagnosticsBrowserOther: 'Other',
    webRTCDiagnosticsBrowserUpdatedLabel: 'Is your web browser up to date?',
    webRTCDiagnosticsBrowserUpdatedUnknown: 'I don\'t know',
    webRTCDiagnosticsBrowserVersionLabel: 'Browser Version',
    webRTCDiagnosticsBrowserVersionPlaceholder: 'e.g. 120.0.6099.129',
    webRTCDiagnosticsInternetConnectionLabel: 'Do you have a stable internet connection?',
    webRTCDiagnosticsInternetConnectionLabelSometimes: 'Sometimes',
    webRTCDiagnosticsSpeedTestLabel: 'Run a speed test',
    webRTCDiagnosticsSpeedTestResultLabel: 'Speed Test Result (optional) or provide a screenshot (upload option at the last step)',
    webRTCDiagnosticsMicrophoneLabel: 'Is your Microphone working in other apps?',
    webRTCDiagnosticsCameraLabel: 'Is your Camera working in other apps?',
    webRTCDiagnosticsPermissionsLabel: 'Have you granted ivCAMPUS permissions to your mic and camera in your browser settings?',
    webRTCDiagnosticsCallIssuesLabel: 'Can you see and hear other participants?',
    webRTCDiagnosticsCallIssuesNoneWorking: 'No (Neither audio nor video)',
    webRTCDiagnosticsCallIssuesAudioOnly: 'I can hear them, but not see them',
    webRTCDiagnosticsCallIssuesVideoOnly: 'I can see them, but not hear them',
    webRTCDiagnosticsCallIssuesChoppy: 'Both audio and video are choppy or unstable',
    webRTCDiagnosticsCallIssues: {
        allWorking: 'all_working',
        noneWorking: 'none_working',
        audioOnly: 'audio_only',
        videoOnly: 'video_only',
        choppy: 'choppy'
    },
    webRTCDiagnosticsChoppyDescriptionLabel: 'Describe the choppy experience',
    webRTCDiagnosticsOthersCanSeeHearLabel: 'Can other participants see and hear you?',

    webRTCDiagnosticsVPNLabel: 'Are you using a VPN?',
    webRTCDiagnosticsManagedITLabel: 'Is your network managed by an IT department?',
    webRTCDiagnosticsRegionalITLabel: 'Is your network managed by an regional IT-supplier?',
    webRTCDiagnosticsAdditionalIssueStartDate: 'When did the issue start?',
    webRTCDiagnosticsAdditionalIssueFrequency: 'Issue frequency (e.g. every call, specific , Home office/Office)',
    webRTCDiagnosticsAdditionalIssueOtherParticipants: 'Are others experiencing the same issue?',
    webRTCDiagnosticsAdditionalIssueAnyOtherIssues: 'Any other relevant details?',
    webRTCDiagnosticsOperatingSystemLabel: 'Select your operating system:',
    webRTCDiagnosticsFirewallTitle: 'Firewall Configuration',
    webRTCDiagnosticsFirewallDescription: 'Please ask an IT colleague to verify if the following servers and ports are allowed in your firewall.',
    webRTCDiagnosticsFirewallTURNServer: 'ivicos-turn.ivicos-campus.app (185.233.188.204)',
    webRTCDiagnosticsFirewallJVBServer: 'ivicos-jvb.ivicos-campus.app (185.233.188.253)',
    webRTCDiagnosticsFirewallJitsiServer: 'ivicos-jitsi.ivicos-campus.app (185.233.189.35)',
    webRTCDiagnosticsFirewallPort80: 'Port 80/tcp (HTTP)',
    webRTCDiagnosticsFirewallPort443: 'Port 443/tcp (HTTPS)',
    webRTCDiagnosticsFirewallPort4443: 'Port 4443/tcp (TCP)',
    webRTCDiagnosticsFirewallPort10000: 'Port 10000/udp (UDP) – Critical for audio/video quality',
    webRTCDiagnosticsScreenshotsTitle: 'Upload Screenshots (optional)',
    webRTCDiagnosticsScreenshotsCount: 'screenshot(s) uploaded',
    webRTCDiagnosticsGenerateReportButton: 'Generate Troubleshooting Report (PDF)',
    webRTCDiagnosticsShowTestEnvironment: {
        show: 'Show Test Environment',
        hide: 'Hide Test Environment',
        title: 'Test Jitsi Environment (optional)',
        step1: 'Step 1: Open an incognito/private window',
        step1Description: 'For the best testing experience, please open the test link in an incognito or private window depending on your browser:',
        command1: 'Press Ctrl+Shift+N (Windows/Linux) or ⌘+Shift+N (Mac)',
        command2: 'Press Ctrl+Shift+P (Windows/Linux) or ⌘+Shift+P (Mac)',
        step2: 'Step 2: copy the below mentioned test link and paste it in the incognito/private window',
        copyLink: 'Copy Link',
        linkCopied: 'Link Copied',
        step3: 'Note: Using an incognito/private window ensures that your current browser sessions and cookies don\'t interfere with the testing environment.'
    },
    webRTCDiagnosticsGeneratedReport: {
        title: 'ivCAMPUS Video Call Troubleshooting Report',
        generatedOn: 'Generated on:',
        basicInformation: 'Basic Information',
        category: 'Category',
        status: 'Status',
        browser: 'Browser',
        browserUpdated: 'Is browser updated?',
        browserVersion: 'Browser version',
        internetConnection: 'Is internet connection stable?',
        speedTestResult: 'Speed test result',
        operatingSystem: 'Operating system',
        deviceChecks: 'Device Checks',
        check: 'Check',
        microphoneWorking: 'Is microphone being used by another application?',
        cameraWorking: 'Is camera being used by another application?',
        permissionsGranted: 'Permissions granted to ivCAMPUS',
        callIssues: 'Call Issues',
        issue: 'Issue',
        callIssuesStatus: 'Call issues',
        othersCanSeeHear: 'Others can see/hear',
        usingVPN: 'Using VPN',
        managedIT: 'Managed IT',
        regionalIT: 'Regional IT',
        choppyDescription: 'Choppy Description',
        firewallConfiguration: 'Firewall Configuration',
        servicePort: 'Service/Port',
        turnServer: 'TURN Server',
        jvbServer: 'JVB Server',
        jitsiServer: 'Jitsi Server',
        port80: 'Port 80',
        port443: 'Port 443',
        port4443: 'Port 4443',
        port10000: 'Port 10000',
        allowed: 'Allowed',
        blocked: 'Blocked',
        additionalInformation: 'Additional Information',
        details: 'Details',
        issueStartDate: 'Issue Start Date',
        issueFrequency: 'Issue Frequency',
        otherParticipantsIssue: 'Other Participants Issue',
        additionalDetails: 'Additional Details',
        screenshots: 'Screenshots',
        screenshot: 'Screenshot',
        errorLoadingScreenshot: 'Error loading screenshot',
        notProvided: 'Not provided',
        page: 'Page',
        of: 'of'
    },
    resetWizard: {
        title: 'Reset Application',
        description1: 'Click the button below to delete the application data from ivCAMPUS, including locally cached content and session information.',
        description2: 'This will help to resolve application issues or conflicts.',
        reset: 'Reset',
        resetComplete: 'Done! All cache and memory data for the ivicos-campus.app page has been removed.'
    },

    // Personal Meeting Corner
    personalMeetingCornerStrings: {
        // Add Widgets
        addWidgets: {
            addWidget: 'Add Widget',
            addWidgetAriaLabel: 'Add Widget'
        },

        // Widget Creation
        createWidget: {
            createWidget: 'Create Personal Widget with Favorite or Tip',
            updateWidget: 'Update Personal Widget with Favorite or Tip',
            close: 'Close',
            artGallery: 'Art Gallery',
            imageUpload: 'Photos',
            quote: 'Quote',
            urls: 'Websites',
            book: 'Book Tip',
            anotherLife: 'Another Life',
            anotherLifeSection: 'Another Life section (to be implemented)',
            preserveAspectRatio: 'Show entire image',
            header: 'Header',
            widgetHeader: 'Widget header',
            footer: 'Footer',
            widgetFooter: 'Widget footer',
            createWidgetButton: 'Create Widget',
            updateWidgetButton: 'Update Widget'
        },

        // Art Gallery Widget
        artGallery: {
            searchPlaceholder: 'Search National Gallery artworks...',
            searchingCollections: 'Searching collections...',
            artist: 'Artist: {artist}',
            medium: 'Medium: {medium}',
            date: 'Date: {date}'
        },

        // Image Upload Widget
        imageUpload: {
            upload: 'Upload',
            searchUnsplashHeader: 'Search Unsplash',
            clickOrDragToUpload: 'Click or drag a photo here to upload',
            searchUnsplash: 'Search Unsplash...',
            loading: 'Loading...',
            description: 'Description',
            photoByAuthor: 'Photo by {authorName} on {unsplash}',
            author: 'Author: {authorName}',
            sourceUnsplash: 'Source: Unsplash',
            imageLink: 'Image Link'
        },

        // Quote Widget
        quote: {
            chooseCategory: 'Choose category...',
            fetchingQuote: 'fetching quote...',
            getQuote: 'Get a quote',
            noQuoteGenerated: 'No quote generated.',
            useThisQuote: 'Use this quote',
            quoteLabel: 'Quote (max. 400 characters)',
            quotePlaceholder: 'Enter your favorite quote...',
            authorLabel: 'Author',
            authorPlaceholder: 'Quote author',
            quoteCategories: {
                inspirational: 'Inspirational',
                motivational: 'Motivational',
                life: 'Life',
                love: 'Love',
                success: 'Success',
                wisdom: 'Wisdom',
                happiness: 'Happiness',
                friendship: 'Friendship'
            }
        },

        // URL Widget
        url: {
            dragDropUrls: 'Drag & drop URLs here from your browser',
            enterUrlsManually: 'Or enter URLs manually in the input field below',
            enterUrlPlaceholder: 'Enter URL (e.g., https://ivicos.eu)',
            add: 'Add',
            links: 'links',
            noLinksAdded: 'No links added yet',
            addFirstLink: 'Add your first recommended link above',
            recommendedLink: 'Recommended Link',
            recommendedLinks: 'Recommended Links',
            recommendedLinksReorder: 'Recommended Links (drag to reorder)',
            pleaseEnterUrl: 'Please enter a URL',
            maxLinksAllowed: 'Maximum 10 links allowed',
            pleaseDropValidUrl: 'Please drop a valid URL',
            openLink: 'Open link',
            removeLink: 'Remove link',
            more: 'more'
        },

        // Book Widget
        book: {
            searchForBook: 'Search for a book',
            searchPlaceholder: 'Title, author, or ISBN',
            searching: 'Searching...',
            search: 'Search',
            pleaseEnterSearchTerm: 'Please enter a search term.',
            searchingBooks: 'Searching books...',
            author: 'Author: {authorName}',
            published: 'Published: {publishedDate}',
            isbn: 'ISBN: {isbnNumber}',
            source: 'Source: ',
            openLibrary: 'Open Library',
            bookCover: 'Book cover',
            fallbackBookCover: {
                bookRecommendation: 'Book Recommendation',
                clickHere: 'click here',
                photoBy: 'Photo by',
                on: 'on'
            }
        },

        // Tooltips
        tooltips: {
            main: {
                personalDashboard: 'My Desktop',
                personalMeetingCorner: 'My Meeting Corner',
                saveChanges: 'Save widgets and return to desktop'
            },
            expandWidgets: 'Show widgets',
            collapseWidgets: 'Hide widgets',
            addWidget: 'Add widget',
            editWidget: 'Edit widget',
            deleteWidget: 'Delete widget',
            openLink: 'Open link in new tab',
            removeLink: 'Remove link'
        }
    },

// SAML
    samlUnknownProviderTitle: 'Unknown login provider',
    samlUnknownProviderMessage: 'The login page you requested does not exist. Please check your link or contact your administrator.',
    samlUnknownProviderBack: 'Back to login',
    dashboardBackgroundImageTitle: 'Dashboard background image',
    dashboardBackgroundModalTitle: 'Dashboard background',
    dashboardBackgroundModalSubtitle: 'Pick a fixed backdrop for every user\'s dashboard. Widgets will scroll over the background.',
    dashboardBackgroundCurrentSelection: 'Current selection',
    disableProviderDialogTitle: 'Disable {0}?',
    disableProviderDialogWarning: 'All {0} widgets on CAMPUS will disappear on all desks.',
    disableProviderDialogCancel: 'Cancel',
    disableProviderDialogConfirm: 'Disable',
    // ZAMMAD SETTINGS
    zammadSettingsToggleLabel: 'Zammad',
    zammadSettingsBaseUrlLabel: 'Zammad Base URL',
    zammadSettingsSaveButton: 'Save',
    zammadSettingsCancelButton: 'Cancel',
    zammadSettingsConfiguredStatus: 'Configured',
    zammadSettingsNotConfiguredStatus: 'Not configured',
    zammadSettingsVerifyFailedError: 'Invalid Base URL or Access Token.',
    // OPENPROJECT SETTINGS
    openProjectSettingsToggleLabel: 'OpenProject',
    openProjectSettingsBaseUrlLabel: 'OpenProject URL',
    openProjectSettingsBaseUrlHint: 'The https address of your OpenProject, e.g. https://openproject.example.com',
    openProjectSettingsSaveButton: 'Save',
    openProjectSettingsCancelButton: 'Cancel',
    openProjectSettingsConfiguredStatus: 'Configured',
    openProjectSettingsNotConfiguredStatus: 'Not configured',
    openProjectSettingsInvalidUrlError: 'Please enter a public https address.'
};
